<template>
  <!-- <v-btn @click="showAlert(Snippet_StatusData)">Click Me</v-btn> -->
  <div
    :style="(Snippet_StatusData ? 'background-color:white;' : 'background-color:white; margin-top: calc(62px)!important;')">
    <v-container fluid>
      <div v-if="Status_Error == false" style="background-color:white !important; padding: 0%; margin: 0%;">

        <v-row style="display: flex;background-color:white; width: 100%; padding: 0%; margin:0%"
          class="d-flex flex-wrap flex-row align-center" justify="end" no-gutters>
          <v-col cols="6"
            style="padding-bottom: 0px; font-size: 15px; display: flex; justify-content: flex-end; margin-right: 20px;">
            <label style="color:#71717A; white-space: nowrap;  overflow: hidden;text-overflow: ellipsis;">
              Model {{ (ModelFirst == "" ? "" : ModelFirst) }}
              {{ (TopicName == "" ? "" : TopicName) }}
            </label>
          </v-col>

          <v-col v-show="Snippet_StatusData" cols="4" class="pa-0 pr-2">
            <div class="d-flex flex-row-reverse align-center justify-start ma-0 ml-auto">
              <div v-show="Snippet_Username == '' || Snippet_Username == null || Snippet_Username == undefined"
                style="background-color: #333; margin-top: 3px; padding: 5px; font-size: 12px; width: 70px; height: 25px; border-radius: 20px; text-align: center; cursor: pointer;"
                v-on:click="OpenTabLogin()">
                <span style="color: white; text-align: center;">
                  LOGIN
                </span>
              </div>
              <v-btn variant="text" v-show="Snippet_Username != ''" icon v-on:click="chatLogout()" hide-details>
                <v-icon>mdi-logout</v-icon>
              </v-btn>
              <span
                style="color: black; text-align: center; font-weight: bold; white-space: nowrap;  overflow: hidden;text-overflow: ellipsis;">
                {{ Snippet_Username }}
              </span>
            </div>
          </v-col>
        </v-row>

        <v-row style="position: static;  background-color:white;"
          :style="(Snippet_StatusData ? 'height: calc(100vh - 52px)!important;' : 'height: calc(100vh - 110px)!important;width: 100%')">
          <v-col id="Col_Snippet" cols="12" style="background-color: white;flex: 1; max-height: 100%!important; padding-right: 3px;
          display: flex; flex-direction: column; align-items: center; ">
            <div id="ChatScreId" style=" width: 100%; height: 100%; min-height: 20vh;  overflow-y: auto; overflow-x: hidden; flex-grow: 1; display: flex;
                max-height: calc(80vh)!important; flex-direction: column; background-color:white;
                border-radius: 5px; margin-bottom: 10px;" ref="ChatScreRef" @scroll="ChatScreScroll">
              <div v-if="Loading_History_Status == true">
                <v-progress-linear indeterminate color="#ff4646" class="mb-0"></v-progress-linear>
              </div>
              <div v-for="(item, index) in listMessage" :id="'ChatId_' + item.id" :key="index">
                <v-row style=" margin: 0px;">
                  <v-col col="12">
                    <div class="d-flex align-end justify-end" :class="xsOnly ? 'flex-row' : ''">
                      <div style="float: right; align-self: center; margin-right:6px;">
                        <label style="font-size: 10px; color: rgb(113, 113, 122); margin-bottom: 0px;">{{
                          item.requestTime }}</label>
                      </div>
                      <div style="float: right; align-self: center;" class="text-truncate">
                        <label>{{ Snippet_Username == '' ? 'You' : Snippet_Username }}</label>
                      </div>
                      <div>
                        <v-btn icon text
                          style="float: right; margin-bottom: 5px;  margin-right: 15px; margin-left:15px;
                          font-size: 16px; font-family: inter,sans-serif;  font-style: normal; background: #D96666; color: rgb(255, 255, 255,1);"
                          disabled fab width="34px" height="34px" class="white--text" :style="'background: #' + (NavbarBtnColorTheme != null || NavbarBtnColorTheme != undefined ?
                            NavbarBtnColorTheme : 'D96666')">
                          <span v-if="User_Id_Show != null && User_Id_Show != '' && User_Id_Show != undefined"
                            class="text-uppercase"
                            style="font-size: 16px; font-family: inter,sans-serif; font-style: normal; color: rgb(255, 255, 255,1) !important;"
                            :style="'color: #' + (NavbarTxtColorTheme != null || NavbarTxtColorTheme != undefined ?
                              NavbarTxtColorTheme : 'FFFFFF') + ' !important'">
                            {{ User_Id_Show.substring(0, 2) }}
                          </span>
                          <v-icon v-else class="text-uppercase"
                            style="font-size: 16px; font-family: inter,sans-serif; font-style: normal; color: rgb(255, 255, 255,1) !important;"
                            :style="'color: #' + (NavbarTxtColorTheme != null || NavbarTxtColorTheme != undefined ?
                              NavbarTxtColorTheme : 'FFFFFF') + ' !important'">
                            mdi-account
                          </v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <div :class="xsOnly ? 'd-flex flex-row justify-end' : ''" style="line-break: anywhere;
                      padding: 16px 20px;
                      border-radius: 8px;
                      font-size: 16px; font-weight: 400; color: #71717A;
                      line-height: 22px; white-space: pre-line; display: flex;
                      width: fit-content; float: right; min-height: 54px;"
                      :style="mdAndUp ? 'max-width: 80%;  margin-top:2px;  margin-right: 6px;  background: rgb(249,249,249);' :
                        xsOnly ? 'max-width: 100%; background: rgb(255,255,255);' : 'max-width: 80%; margin-top:2px;  margin-right: 6px;  background: rgb(249,249,249);'">
                      {{ item.messageUser }}
                    </div>
                  </v-col>
                </v-row>
                <v-row style=" margin: 0px;" v-if="item.status_Process != 'VoiceStart'">
                  <v-col col="12">
                    <div class="d-flex flex-row align-end justify-start">
                      <div style="float: left; height: 35px; width: 35px;  border-radius: 50%;
                                text-align: center;  background-color: white; 
                                margin-top: 10px; margin-right: 15px;">
                        <div class="rotating-element" v-if="item.status_Process == 'Process'" style="display: flex; justify-content: center; align-items: center; position: relative;margin-top: -5px;scale: .8;">
                            <div class="botloader"></div>
                            <div class="botringloader" style="position: absolute;"></div>
                        </div>
                        <v-icon v-else-if="!isImgIconChat" style="font-size: 30px;"
                          :style="'color:' + selectedColor + ';'">{{ ChatbotIcon != null ? ChatbotIcon :
                          'mdi-robot-outline'}}</v-icon>
                        <v-img v-else style="height: 35px; width: 35px; border-radius: 50%;" :src="IconChat" />
                      </div>
                      <div style="align-self: center;">
                        <label>{{ ChatbotName }}</label>
                      </div>
                      <div style="align-self: center; margin-left:6px;">
                        <label style="font-size: 10px; color: rgb(113, 113, 122); margin-bottom: 0px;">{{
                          item.responseTime }}</label>
                      </div>
                    </div>
                    <div class="d-flex flex-row" :class="xsOnly ? 'justify-start' : ''">
                      <div v-if="item.status_Process == 'Process'" style=" background: rgb(249, 249, 249);  border-radius: 8px; 
                            box-shadow: rgba(0, 0, 0, 0.14) 0px 2px 4px, rgba(0, 0, 0, 0.12) 0px 0px 2px;
                                font-size: 16px;    font-weight: 400;    float: left;    width: 175px;">
                        <!-- <div style="padding-top: 10px;    padding-left: 10px;"> Finding answer ...</div>
                        <div style="padding: 10px;">
                          <v-progress-linear indeterminate color="rgb(0, 120, 212)" class="mb-0"></v-progress-linear>
                        </div> -->
                      </div>

                      <div v-else-if="item.status_Process == 'Send_Message' || item.status_Process == 'END'" style="line-break: anywhere;
                      padding: 0px 20px 16px 20px;
                      border-radius: 8px;
                      font-size: 16px;    font-weight: 400;
                      line-height: 22px;    white-space:  pre-line;    display: flex;
                      width: fit-content;    float: left; "
                        :style="xsOnly ? 'max-width: 100%; background: rgb(255,255,255);' : 'max-width: 80%; background: rgb(249,249,249);'"
                        @click="botMessageClick(item.messageBot)">
                        <vue-markdown id="V_markDown2" :anchor-attributes="anchorAttrs" :content="item.messageBot"
                          style="color: #71717A;">
                        </vue-markdown>
                      </div>

                      <!-- Error -->
                      <div v-else style="line-break: anywhere;
                      padding: 16px 20px; background: rgb(249,249,249);
                      border-radius: 8px;
                      font-size: 16px;    font-weight: 400;
                      line-height: 22px;    white-space:  pre-line; 
                      width: fit-content;    float: left;"
                        :style="xsOnly ? 'max-width: 100%; background: rgb(255,255,255);' : 'max-width: 80%; background: rgb(249,249,249);'">
                        <vue-markdown id="V_markDown2" :anchor-attributes="anchorAttrs" :content="item.messageBot"
                          style="color: #71717A;">
                        </vue-markdown>
                        <span> ...{{ item.status_Process }}</span>
                      </div>
                    </div>
                    <!-- Like and Dislike button -->
                    <!-- <div v-if="((!Snippet_Username == false && Snippet_Status) || !Snippet_Status ) && item.status_Process == 'END'" style="float: left;" >
                        <v-btn
                          v-if="item.status == null || item.status == 0" icon :color="selectedColor"
                          @click="ThisFeedBackResponse(item,1)">
                          <v-icon size="20px">mdi-thumb-up-outline</v-icon>
                        </v-btn>
                        <v-btn
                          v-else-if="item.status == 1" icon :color="selectedColor"
                          @click="item.status = null; closeDialog(item);">
                          <v-icon  size="20px">mdi-thumb-up</v-icon>
                        </v-btn>

                        <v-btn :value="0"
                          v-if="item.status == null || item.status == 1" icon :color="selectedColor"
                          @click="openCommentDialog(item,index)"
                          >
                          <v-icon  size="20px">mdi-thumb-down-outline</v-icon>
                        </v-btn>

                        <v-btn :value="0"
                          v-else-if="item.status == 0" icon :color="selectedColor"
                          @click="item.status = null; closeDialog(item)"
                          >
                          <v-icon  size="20px">mdi-thumb-down</v-icon>
                        </v-btn>

                      <v-btn icon :color="selectedColor"
                        @click="Clipboard(item)">
                        <v-icon size="20px">mdi-content-copy</v-icon>
                      </v-btn>
                    </div> -->
                  </v-col>
                  <v-expand-transition>
                    <div v-show="item.commentDialog" style="width:calc(100vi - 24px); position: sticky; bottom: 4px;">
                      <v-card class="mx-auto" outlined>
                        <v-card-title>
                          Tell us more:
                          <v-spacer></v-spacer>
                          <v-btn @click="$set(item, 'commentDialog', false); item.status = null;" icon>
                            <v-icon> mdi-close </v-icon>
                          </v-btn>
                        </v-card-title>
                        <v-card-subtitle>
                          Provide additional feedback
                        </v-card-subtitle>
                        <v-card-text :class="!item.moreComment ? 'pb-4' : 'pb-0'" class="py-0">
                          <!-- {{item.SelectComment}} -->
                          <v-chip-group column v-model="item.SelectComment">
                            <!-- {{item.SelectComment }} -->
                            <v-chip filter class="ma-1" :color="selectedColor" text-color="white"
                              @click="item.comment = item.comment != `Don't like the style` ? `Don't like the style` : '';">
                              Don't like the style
                            </v-chip>
                            <v-chip filter class="ma-1" :color="selectedColor" text-color="white"
                              @click="item.comment = item.comment != `Not factually correct` ? `Not factually correct` : '';">
                              Not factually correct
                            </v-chip>
                            <v-chip filter class="ma-1" :color="selectedColor" text-color="white"
                              @click="item.comment = item.comment != `Didn't fully follow instructions` ? `Didn't fully follow instructions` : '';">
                              Didn't fully follow instructions
                            </v-chip>
                            <v-chip filter class="ma-1" :color="selectedColor" text-color="white"
                              @click="item.comment = item.comment != `Refused when it shouldn't have` ? `Refused when it shouldn't have` : '';">
                              Refused when it shouldn't have
                            </v-chip>
                            <v-chip class="ma-1" :color="selectedColor" text-color="white"
                              @click="item.comment = ''; item.moreComment = !item.moreComment">
                              More...
                            </v-chip>
                          </v-chip-group>
                        </v-card-text>
                        <v-card-text v-show="item.moreComment">
                          <v-textarea @click.stop="" rows="2" auto-grow row-height="5" v-model="item.comment"
                            counter="100" maxlength="100" outlined solo label="More details">
                          </v-textarea>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end">
                          <v-btn dense plain :disabled="item.comment == null || item.comment == ''" rounded
                            class="mb-4 mr-4" @click="ThisFeedBackResponse(item, 0);">
                            Send
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </div>
                  </v-expand-transition>
                </v-row>

              </div>

              <div ref="ChatRef"></div>

            </div>
            <v-spacer></v-spacer>
            <div style="width: 100%; display: flex;
              flex-direction: row; position: sticky; bottom: 0px;
              background-color: #FFFFFF;">

              <div style="width: 100%;padding: 0">
                <div class="chat-input-container">
                  <v-textarea id="D_MessageData" ref="RefMessageData" v-model="messageData" :value="messageData"
                    class="message-textarea" placeholder="Type your message here..." :maxlength="maximumChatInput" auto-grow rows="1" hide-details variant="outlined"
                    density="comfortable" bg-color="surface" rounded="lg" @click:clear="messageData = ''"
                    v-on:keydown.enter.shift="Key_Ctrl_Flag = true"
                    @keydown.enter.exact.prevent="SendOpenAi('Enter'); Key_Ctrl_Flag = false;">
                    <template v-slot:append-inner>
                      
                      <!-- <div class="input-hint d-none d-sm-flex mr-6">
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }">
                            <v-icon v-bind="props" color="text-disabled" size="small">mdi-information-outline</v-icon>
                          </template>
                          <span>Shift + Enter for new line</span>
                        </v-tooltip>
                      </div> -->
                      <div class="d-flex align-center">
                        <!-- Character counter -->

                        <!-- Send button -->
                        <v-fade-transition>
                          <v-btn v-show="messageData.length > 0 && (listMessage.length === 0 ||
                            listMessage[listMessage.length - 1].status_Process === 'Stop' ||
                            listMessage[listMessage.length - 1].status_Process === 'END' ||
                            listMessage[listMessage.length - 1].status_Process === 'Error')" :color="selectedColor"
                            :disabled="listMessage.length > 0 &&
                              listMessage[listMessage.length - 1].status_Process !== 'END' &&
                              listMessage[listMessage.length - 1].status_Process !== 'Stop' &&
                              listMessage[listMessage.length - 1].status_Process !== 'Error'" density="comfortable"
                            icon="mdi-send" variant="text" @click="SendOpenAi('Click')"></v-btn>
                        </v-fade-transition>

                        <!-- Stop button -->
                        <v-fade-transition>
                          <v-btn v-show="listMessage.length > 0 && (
                            listMessage[listMessage.length - 1].status_Process === 'Process' ||
                            listMessage[listMessage.length - 1].status_Process === 'Send_Message' ||
                            listMessage[listMessage.length - 1].status_Process === 'VoiceStart')"
                            :color="selectedColor" density="comfortable" icon="mdi-stop-circle" variant="text"
                            @click="StopMessage"></v-btn>
                        </v-fade-transition>
                      </div>
                    </template>
                  </v-textarea>

                  <!-- <div class="shortcuts-hint d-block d-sm-none text-caption text-disabled px-2">
                    {{ messageData.length }}/{{ maximumChatInput }}
                  </div> -->
                </div>
              </div>
            </div>
            <div class="shortcuts-hint d-flex justify-space-between text-caption text-disabled px-2">
              
              <label style="color: #5F5F5F;"> {{ versioning != '' ||
              versioning != null ? 'Version' : ''}} {{ 'R' + versioning }} </label>
              <p>{{ messageData.length }}/{{ maximumChatInput }}</p>
            </div>
          </v-col>
          <!-- <label style="position:fixed; font-size: 12px; right:10px; bottom:0px; color: #5F5F5F;"> {{ versioning != '' ||
            versioning != null ? 'Version' : ''}} {{ 'R' + versioning }} </label> -->
            
        </v-row>
        <!-- Product recommendations section - MOVED HERE -->
        <v-row v-show="products && products.length > 0 && !hideProducts"
          style="background-color:white; grid-area: products; margin: 0; padding: 0;" no-gutters>
          <v-col cols="12" class="pa-0">
            <div class="product-recommendations">
              <div class="product-header">
                <h3 class="product-title">สินค้าที่แนะนำ</h3>
                <div class="product-controls">
                  <v-btn size="x-small" variant="text" color="primary" @click="hideProducts = true">
                    ซ่อนสินค้าแนะนำ
                  </v-btn>
                </div>
              </div>
              
              <div class="product-carousel">
                <div class="product-scroll">
                  <div v-for="(product, index) in products" :key="index" class="product-item">
                    <v-card class="product-card-compact" hover @click="showProductDetail(product)">
                      <div class="product-img-container">
                        <v-img
                          v-if="product.ProductImg"
                          :src="product.ProductImg"
                          height="80px"
                          width="80px"
                          class="product-thumbnail"
                          :alt="product.ProductName"
                        ></v-img>
                        <v-img
                          v-else
                          src="@/assets/images/No_Image.png"
                          height="80px"
                          width="80px"
                          class="product-thumbnail"
                          :alt="product.ProductName"
                        ></v-img>
                      </div>
                      <div class="product-info">
                        <div class="product-name-compact">{{ product.ProductName }}</div>
                        <div class="product-price">{{ product.ProductPrice ? `฿${product.ProductPrice.toLocaleString()}` : 'ติดต่อสอบถาม' }}</div>
                      </div>
                      <div class="product-interest-btn">
                        <v-btn
                          size="x-small"
                          variant="outlined"
                          color="primary"
                          @click.stop="selectProduct(product)"
                        >
                          สนใจ
                        </v-btn>
                      </div>
                    </v-card>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>

      </div>

      <div v-else-if="Status_Error == null"> {{ Text_Status }}</div>

      <h1 v-else style="position: fixed;
        top: 50%;
        left: 50%;
        margin-top: -50px;
        margin-left: -100px;">Access Denied</h1>
    </v-container>
    <v-dialog v-model="showImage" max-width="1000" style="background-color: #00000099;">
      <v-card style="
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: transparent;
          box-shadow: none;
          overflow: hidden;
        ">
        <v-img :src="dialogImage" contain style="
            width: 100%;
            height: 250px !important;
            object-fit: contain;
          " />
      </v-card>
      <div style="
          position: absolute;
          bottom: -60px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          justify-content: center;
          gap: 8px;
          z-index: 1000;
          opacity: 0;
          animation: fadeUp 0.3s ease forwards 0.3s;
        ">
        <div class="downloadImgBtn" style="background-color:#faa91b;" @click="downloadImage">
          <v-icon color="white">mdi-download</v-icon>
        </div>
        <div class="downloadImgBtn" style="background-color:#FF4444;" fab @click="closeImage">
          <v-icon color="white">mdi-close</v-icon>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
// import { app } from "@microsoft/teams-js";
import VueMarkdown from '@/components/MarkedMarkdown.vue';
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import Cookies from "js-cookie";
import { version } from "../../../package.json"
import { useDisplay } from "vuetify";
import { mapState } from 'vuex';
const API_BASE_URL = import.meta.env?.VITE_APP_API
export default {
  name: "Snippet",
  inject: ['User_Id_Show', 'User_Id', 'Log_History_TopicID', 'KeyTopic', 'TopicName', 'TopicModelID', 'TopicModelID_long'
    , 'Flag_Click_History', 'listTopic', 'Log_History_ID', 'Loading_History_Status', 'Log_History_Take', 'Snippet_Status'
    , 'colorThemeChat', 'ModelFirst', 'GetModelFirst', 'Snippet_Username', 'NavbarBtnColorTheme', 'NavbarTxtColorTheme', 'Status_Error'
    , 'isImgIconChat', 'ChatbotIcon', 'IconChat', 'ChatbotName', 'maximumChatInput', 'SubscriptionKey', 'Region', 'Time_Delay'
  ],
  components: {
    VueMarkdown
  },
  setup() {
    const { mobile, smAndDown, mdAndUp, xs } = useDisplay();

    return {
      mobile,
      smAndDown,
      mdAndUp,
      xsOnly: xs,
    };
  },
  watch: {
    "User_Id_Show": function () {
      var that = this;
      if (that.Flag_Start) {

        that.User_Id_Show = (that.User_Id_Show == null ? '' : that.User_Id_Show);
        that.User_Id = (that.User_Id == null ? '' : that.User_Id);
        if (that.User_Id_Show != null && that.User_Id_Show != "" && that.User_Id_Show.replace(/ /g, '') != "") {

          that.User_Id = that.User_Id_Show;

        }
        else if (that.User_Id_Show.replace(/ /g, '') == "" && that.User_Id.split('-').length == 6) {
          console.log("User_Id_Show : " + that.User_Id_Show + " ,User_Id-length : " + that.User_Id.split('-').length);
        }
        else {
          that.User_Id = that.GetUuidv4_Fun_User_Id_Null();
        }

      }
      else {
        // that.Flag_Start = true;
      }


    },


    "User_Id": function () {
      var that = this;
      if (that.Flag_Start) {

        that.listMessage = [];
        that.Log_History_TopicID = -1;
        that.TopicName = "";
        that.TopicModelID = "";
        that.KeyTopic = "";

        that.TopicModelID_long = -1;
        that.Chang_History();
        that.GetTopicStream("Start");

        that.GetModelFirst_Value(null, self.User_Id);
      }
      else {
        that.Flag_Start = true;
      }


    },
    "Flag_Click_History": function () {
      var that = this;
      that.listMessage = [];
      if (that.Log_History_TopicID != -1) {
        that.Chang_History();
        that.GetTopicStream("ChangHistory");
      }

    },

    AutoOpenMenu: function async() {
      let self = this;
      self.menuModel = true;
    },
    isShowMore: {
      handler() {
        this.$nextTick(() => {
          this.menuModel = !this.menuModel
        })
      },
      deep: true,
    },
    ColorThemeChat(newVal) {
      this.selectedColor = `#${newVal}`;
    },
    products(newProducts) {
      if (newProducts && newProducts.length > 0) {
        // เมื่อมีสินค้าใหม่เข้ามา อาจมีการแจ้งเตือนหรือแสดง badge
        this.showProductBadge = true;
        this.hideProducts = false;
      }
    }
  },
  computed: {
    ...mapState(['Snippet_StatusData']),
    ColorThemeChat() {
      return this.colorThemeChat;
    },
    headers_ListFilePM() {
      return [
        { title: this.$t('no'), align: 'center', sortable: false, },
        { title: this.$t('StreamFileNamePrivateMemory'), value: 'fileName', align: 'center', sortable: true },
        { title: this.$t('manage'), align: 'center', sortable: false },
      ];
    },
    headers() {
      return [
        {
          title: this.$t('no'),
          align: 'center',
          sortable: false,
        },
        { title: 'text_org', value: 'TextORG', align: 'center', sortable: true },
        { title: 'text_en', value: 'TextEN', align: 'center', sortable: true },
        { title: this.$t('manage'), align: 'center', sortable: false },
      ];
    },
    headersTemplate() {
      return [
        { title: 'Type', align: 'center', width: '25%' },
        { title: 'CSV', align: 'center' },
        { title: 'Excel', align: 'center' },
        { title: 'PDF', align: 'center' },
        { title: 'Word', align: 'center', },
        { title: 'PowerPoint', align: 'center' },
        { title: 'Text', align: 'center' },

      ];
    },
  },
  data: () => ({
    showProductDialog: false,
    showProductBadge: true,
    hideProducts: false,
    showDetailDialog: false,
    selectedProductDetail: null,
    products: [],
    productsSelect: [],
    TimeOutText_Run: null,
    // KeyTopic: null,

    Flag_Start: false,

    messageImage: "",
    LastScrollTop: null,



    TimeOutStop: null,

    // 5 s
    TimeoutFirst: 5000,
    //Timeout: 60000,
    // 10 s
    //Timeout: 10000,
    // 7 s
    Timeout: 7000,
    // Timeout: 10000,
    SpeechRecognizer: null,



    LangPop: "th-TH",
    UserPrincipalName: "",
    anchorAttrs: {
      target: '_blank',
      rel: 'noopener noreferrer nofollow'
    },
    point: 0,
    Key_Ctrl_Flag: false,
    Stop_Flag: false,
    Axios_Controller: null,
    Axios_ControllerAduio: null,
    listMessage: [],
    messageData: "",
    CountScroll: 0,
    MaxCountScroll: 15,
    messageRes: "",
    Count_messageRes: 0,
    StatusPro: false,
    messageRun: "",
    Text_Status: "",
    auth_token: "",
    parameterURL: [],
    groupModel: "",
    snippet_StatusLocal: false,
    ModelQuick: [],
    selectedColor: '#FFA41E',
    isShowMore: false,
    menuModel: false,
    // AllModelDB: [],
    AutoOpenMenu: false,
    today: null,
    menuGroupModel: false,
    showMenu: false,
    comment: false,
    moreComment: false,
    versioning: version,
    URL_Domain: "",
    snipet_flag: false,
    modelDisplayID: "",
    userChanel: "",
    tokenParam: "",
    personalInfoToken: null,
    showImage: false,
    dialogImage: "",
  }),
  methods: {
    downloadImage() {
      let self = this;
      if (!this.dialogImage) return;
      self.alertDialog = true;
      this.closeDownloadDialog();
      self.$call.DownloadChatImage(
        this.dialogImage,
        self.auth_token_local,
        async (dataResponse) => {
          const blob = new Blob([dataResponse], { type: "image/png" });
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = function () {
            const link = document.createElement("a");
            link.href = reader.result; // ใช้ Data URL
            link.download = "downloaded-image.png";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          };
          self.dialog_version = false;
          self.loading = false;
        },
        (errorResource) => {
          self.loading = false;
          self.isSearch = false;
          self.dialog_version = false;
          console.error(errorResource);
        }
      );
    },
    closeImage() {
      this.showImage = false;
      this.dialogImage = "";
    },
    closeDownloadDialog() {
      setTimeout(() => {
        this.alertDialog = false;
      }, 3000);
    },
    botMessageClick(e) {
      const imageRegex = /!\[.*?\]\((.*?)\)/;
      const match = e.match(imageRegex);
      if (match) {
        this.dialogImage = match[1]; // extracted URL
        this.showImage = true;
      }
    },
    showProductDetail(product) {
      this.selectedProductDetail = product;
      this.showDetailDialog = true;
    }, 
    selectProduct(product) {
      // ส่งคำถามเกี่ยวกับสินค้าที่เลือกไปยัง chatbot
      this.messageData = `ฉันสนใจสินค้า: ${product.ProductName}`;
      this.productsSelect.push(product.ProductID);
      this.SendOpenAi('Click');
      
      // บันทึกการเลือกสินค้า
      this.logProductSelection(product);
    },
    logProductSelection(product) {
      console.log(`User selected product: ${product.ProductName}`);
      this.showProductBadge = false;
    },
    async GetCheckAnonymous() {
      try {
        let self = this;
        if (
          (Cookies.get('token_Snippet') != null && Cookies.get('username_Snippet') != null && Cookies.get('email_Snippet') != null)
          || (sessionStorage.getItem("token_Snippet") != null && sessionStorage.getItem("username_Snippet") != null && sessionStorage.getItem("email_Snippet") != null)
        ) {
          return;
        }
        else {
          self.$call.GetCheckAnonymous(
            (dataResponse) => {
              if (dataResponse.status == 0) {
                if (dataResponse.data != "1") {
                  self.OpenTabLogin();
                }
              }
            },
            (errorResource) => {
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        // this.LogTrace(error, 'Get');

        console.log('catch : Get');
      }
    },

    async OpenTabLogin() {
      let self = this;
      if (self.$route.name != 'LoginSnippet') {
        self.$router.push({
          name: 'LoginSnippet',
          params: { path: self.pathUrl },
          query: self.$route.query
        })
      }
    },
    chatLogout() {
      let self = this;
      self.$swal.fire({
        icon: 'success',
        title: 'Logout success',
        showConfirmButton: false,
        timer: 1500,
      }).then(() => {
        sessionStorage.removeItem('token_Snippet');
        sessionStorage.removeItem('username_Snippet');
        sessionStorage.removeItem('email_Snippet');
        sessionStorage.removeItem('isSnippet');

        localStorage.removeItem('token_Snippet');
        localStorage.removeItem('username_Snippet');
        localStorage.removeItem('email_Snippet');
        localStorage.removeItem('isSnippet');

        Cookies.remove('token_Snippet');
        Cookies.remove('username_Snippet');
        Cookies.remove('email_Snippet');
        Cookies.remove('isSnippet');
        window.location.reload();
      });
    },
    SetTimeout(time) {
      let that = this;
      return setTimeout(() => {


        that.Click_StopVoice();

        console.log("End : " + new Date().toJSON())
      }, time)
    },

    Click_StartVoice() {

      /* eslint-disable */

      let that = this;
      that.messageData = "";

      let _SpeechSDK = SpeechSDK;
      const audioConfig = _SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();

      //  const speechConfig = _SpeechSDK.SpeechConfig.fromSubscription("6f537e8f596943498c6d0bf2ec548b1a", "southeastasia");


      const speechConfig = _SpeechSDK.SpeechConfig.fromSubscription(that.SubscriptionKey, that.Region);

      // speechConfig.setProperty(_SpeechSDK.PropertyId[_SpeechSDK.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs], "1000");

      // speechConfig.outputFormat = _SpeechSDK.OutputFormat.Detailed;

      // speechConfig.speechRecognitionLanguage = that.LangPop ; 


      speechConfig.setProperty(_SpeechSDK.PropertyId[_SpeechSDK.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs], "1500");
      //  speechConfig.setProperty(_SpeechSDK.PropertyId[_SpeechSDK.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs], "1600");


      speechConfig.setProperty(_SpeechSDK.PropertyId[_SpeechSDK.PropertyId.SpeechServiceConnection_LanguageIdMode], "Continuous");
      /*
            speechConfig.setProperty(_SpeechSDK.PropertyId[_SpeechSDK.PropertyId.SpeechServiceConnection_LanguageIdMode], "Continuous");
      
      
      
            var autoDetectSourceLanguageConfig = _SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages(["en-US", "th-TH"]);
      
            that.SpeechRecognizer = _SpeechSDK.SpeechRecognizer.FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig);
      
      */

      let autoDetectSourceLanguageConfig = _SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages([that.LangPop]);

      that.SpeechRecognizer = _SpeechSDK.SpeechRecognizer.FromConfig(speechConfig, autoDetectSourceLanguageConfig, audioConfig);


      setTimeout(() => {
        that.CountScroll = that.MaxCountScroll;
        that.ChatRef_ScrollIntoView();
      }, 5);

      let _temp_text = "";

      let _temp_textOld = "";
      that.SpeechRecognizer.recognizing = (s, e) => {

        if (that.TimeOutStop != null) {

          clearTimeout(that.TimeOutStop);
          that.TimeOutStop = null;
        }
        console.log(`TRANSLATING: Text=${e.result.text}`);


        if (that.listMessage.length > 0) {

          if (that.listMessage[that.listMessage.length - 1].messageBot == "-") {

            that.listMessage[that.listMessage.length - 1].messageBot = "*";
            that.listMessage[that.listMessage.length - 1].messageUser = "";
          }



          that.listMessage[that.listMessage.length - 1].messageUser = _temp_textOld + (
            (_temp_textOld == ""
            ) ? "" : " ") + e.result.text;
        }

        // that.messageData += "\n"+ e.result.text;
      };
      that.SpeechRecognizer.recognized = (s, e) => {


        if (e.result.reason == _SpeechSDK.ResultReason.RecognizedSpeech) {

          // console.log(`TRANSLATED: Text=${e.result.text}`);

          // that.messageData += " " + e.result.text;

          if (that.listMessage.length > 0) {

            if (that.listMessage[that.listMessage.length - 1].messageBot == "-") {

              that.listMessage[that.listMessage.length - 1].messageBot = "*";
              that.listMessage[that.listMessage.length - 1].messageUser = "";
            }


            that.listMessage[that.listMessage.length - 1].messageUser = _temp_text + (
              (_temp_text == ""
              ) ? "" : "") + e.result.text;

            _temp_text += ((_temp_text == "") ? "" : "") + e.result.text;

            _temp_textOld = that.listMessage[that.listMessage.length - 1].messageUser;

          }

          console.log(`recognized: Text=${e.result.text}`);
        }
        else if (e.result.reason == _SpeechSDK.ResultReason.NoMatch) {
          console.log("NOMATCH: Speech could not be translated.");

        }
        else {
          console.log("ss " + e.result.reason)
        }
      };

      that.SpeechRecognizer.canceled = (s, e) => {

        console.log("canceled.");

        if (that.TimeOutStop != null) {

          clearTimeout(that.TimeOutStop);
          that.TimeOutStop = null;
        }
      };

      that.SpeechRecognizer.sessionStarted = (s, e) => {

        console.log("sessionStarted.");

        if (that.TimeOutStop != null) {

          clearTimeout(that.TimeOutStop);
          that.TimeOutStop = null;
        }
        console.log("Start : " + new Date().toJSON())

        that.TimeOutStop = that.SetTimeout(that.TimeoutFirst);
        /*
        that.TimeOutStop = setTimeout(() => {
 
 
          that.Click_StopVoice();
 
          console.log("End : " + new Date().toJSON())
        }, that.TimeoutFirst);
*/



      };

      that.SpeechRecognizer.sessionStopped = (s, e) => {


        if (that.TimeOutStop != null) {

          clearTimeout(that.TimeOutStop);
          that.TimeOutStop = null;
        }
        console.log("sessionStopped.");
        if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].messageBot == "*") {


          that.messageData = that.listMessage[that.listMessage.length - 1].messageUser;
          if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process == 'VoiceStart') {

            that.listMessage.pop();
          }
          that.SendOpenAi('Click');
        }
        else if (that.listMessage.length > 0) {
          if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process == 'VoiceStart') {
            that.listMessage.pop();
          }
        }
      };
      that.SpeechRecognizer.speechStartDetected = (s, e) => {
        console.log("(StartDetected) SessionId: " + e.sessionId);
        if (that.TimeOutStop != null) {
          clearTimeout(that.TimeOutStop);
        }
      };
      that.SpeechRecognizer.speechEndDetected = (s, e) => {
        console.log("(EndDetected) SessionId: " + e.sessionId);
        if (that.TimeOutStop != null) {

          clearTimeout(that.TimeOutStop);
          that.TimeOutStop = null;
        }
        console.log("Start : " + new Date().toJSON())
        that.TimeOutStop = that.SetTimeout(that.Timeout);
      };
      that.SpeechRecognizer.startContinuousRecognitionAsync((e) => {
      }, (error) => {
        if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process == 'VoiceStart'
          && error == "Error occurred during microphone initialization: NotAllowedError: Permission denied"
        ) {
          that.listMessage[that.listMessage.length - 1].status_Process = 'END'
          that.listMessage[that.listMessage.length - 1].messageBot = "ไม่มีสิทธ์เข้าถึงไมค์";
        }
        else if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process == 'VoiceStart'
        ) {
          that.listMessage[that.listMessage.length - 1].status_Process = 'END'
          that.listMessage[that.listMessage.length - 1].messageBot = "เกิดข้อผิดพลาด";
        }
        else {
          that.listMessage.push({
            messageUser: "พูด...",
            messageBot: "เกิดข้อผิดพลาด",
            status_Process: "END"
          });
        }
        setTimeout(() => {
          that.CountScroll = that.MaxCountScroll;
          that.ChatRef_ScrollIntoView();
        }, 5);
      });
      if (that.listMessage.length > 0 &&
        that.listMessage[that.listMessage.length - 1].status_Process == 'END'
        && that.listMessage[that.listMessage.length - 1].messageBot.length < that.messageRes.length) {
        that.Count_messageRes = 0;
        that.StatusPro = true;
        that.loading = true;
        that.messageRun = "";
        that.listMessage[that.listMessage.length - 1].messageBot = that.messageRes;
        that.messageRes = "";
      }
      that.listMessage.push({
        messageUser: "พูด...",
        messageBot: "-",
        status_Process: "VoiceStart"
      });
    },
    Convest_Speech_To_Text(Ob_DataFile) {
      let that = this;
      let formData = new FormData();
      let OB_DF = Ob_DataFile;
      if (that.listMessage.length > 0 &&
        that.listMessage[that.listMessage.length - 1].status_Process == 'END'
        && that.listMessage[that.listMessage.length - 1].messageBot.length < that.messageRes.length) {
        that.Count_messageRes = 0;
        that.StatusPro = true;
        that.loading = true;
        that.messageRun = "";
        that.listMessage[that.listMessage.length - 1].messageBot = that.messageRes;
        that.messageRes = "";
      }

      if (OB_DF.Status == false) {
        that.listMessage.push({
          messageUser: "ไฟล์เสียง",
          messageBot: OB_DF.manualContent,
          status_Process: "END"
        });
        setTimeout(() => {
          that.CountScroll = that.MaxCountScroll;
          that.ChatRef_ScrollIntoView();
        }, 5);
        return;
      } else {
        that.listMessage.push({
          messageUser: "ไฟล์เสียง " + OB_DF.NameFile,
          messageBot: "",
          status_Process: "Process"
        });


        setTimeout(() => {
          that.CountScroll = that.MaxCountScroll;
          that.ChatRef_ScrollIntoView();
        }, 5);

      }


      that.Axios_ControllerAduio = new AbortController();

      let Config = {
        signal: that.Axios_ControllerAduio.signal
      }

      formData.append("FileSoeech", OB_DF.DataFile);
      formData.append("LangPop", that.LangPop);

      that.$call.GetConvest_Speech_To_Text(formData, Config, (response) => {

        if (response.status == 0 && response.data.status == true) {
          that.listMessage.pop();
          if (response.data.data != "") {

            that.messageData = response.data.data;
            that.SendOpenAi('Click');

          } else {

            that.listMessage.push({
              messageUser: "ไม่พบข้อมูลเสียงในไฟล์",
              messageBot: "",
              status_Process: "END"
            });
          }
        }
        else {
          if (that.listMessage.length > 0) {
            that.listMessage[that.listMessage.length - 1].messageBot = response.data.textError;
            that.listMessage[that.listMessage.length - 1].status_Process = "END";
          }

        }
      },
        () => {

          if (that.listMessage.length > 0) {
            that.listMessage[that.listMessage.length - 1].messageBot = "แปลงไฟล์เสียงไม่ได้";
            that.listMessage[that.listMessage.length - 1].status_Process = "END";
          }
        });



    },
    Click_FileButtonVoid() {
      var that = this;
      if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].status_Process != 'END' &&
        that.listMessage[that.listMessage.length - 1].status_Process != 'Stop') {
        return;
      }

      document.getElementById("inputFileVoid").click();
    },
    Chang_InputFileVoid(e) {
      let that = this;
      const files = e.target.files;

      if ((files[0] == undefined)) {
        return;
      }
      if (files[0] !== undefined && (files[0].type == "audio/wav" || files[0].type == "audio/mpeg"
        || files[0].type == "audio/x-m4a")) {
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {

          let Output = {
            Status: true,
            NameFile: files[0].name,
            DataFile: files[0],
            manualContent: files[0].type
          }
          document.getElementById("inputFileVoid").value = "";
          that.Convest_Speech_To_Text(Output);
        });
      } else {
        let Output = {
          Status: false,
          NameFile: null,
          DataFile: null,
          manualContent: "รองรับไฟล์ MP3, WAV และ M4A เท่านั้น"
        }
        document.getElementById("inputFileVoid").value = "";

        that.Convest_Speech_To_Text(Output);
      }

    },


    GetUuidAll() {
      let that = this;
      if (that.parameterURL.userid == null || that.parameterURL.userid == undefined || that.parameterURL.userid == "") {
        // that.GetUuidv4();
        that.Flag_Start = false;
        that.GetUuidv4();
      }
      else {
        that.Flag_Start = true;
        that.User_Id = that.parameterURL.userid;
        that.User_Id_Show = that.parameterURL.userid;
      }
    },

    GetUuidv4_BK() {
      let that = this;
      if (that.User_Id == null || that.User_Id == undefined || that.User_Id == "") {
        let Uuid = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
        that.User_Id = Uuid;
        that.User_Id_Show = Uuid;
      }
    },

    GetUuidv4() {
      let that = this;
      if (that.User_Id == null || that.User_Id == undefined || that.User_Id == "") {
        let Uuid = that.GetUuidv4_Fun();
        that.User_Id = Uuid;
        that.User_Id_Show = Uuid;
        that.GetTopicStream("Start");
      }
    },
    GetUuidv4_Fun() {
      let that = this;
      let Uuid = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
      return Uuid;
    },

    GetUuidv4_Fun_User_Id_Null() {
      let that = this;
      let Uuid = "10000000-1000-4000-8000-100000000000-9000".replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
      return Uuid;
    },

    Shift_Enter_MessageData() {

      let that = this;


      that.point = that.$refs.RefMessageData.$refs.input.selectionStart;
      let _point = (that.$refs.RefMessageData.$refs.input.selectionStart - 1);


      that.$nextTick(() => {
        that.$refs.RefMessageData.$refs.input.selectionStart = _point + 2;
        that.$refs.RefMessageData.$refs.input.selectionEnd = _point + 2;

        if (that.$refs.RefMessageData.$refs.input &&
          that.$refs.RefMessageData.$refs.input.selectionStart >= that.messageData.length

        ) {
          const height = that.$refs.RefMessageData.$refs.input.scrollHeight
          // This has to be done ASAP, waiting for Vue
          // to update the DOM causes ugly layout jumping
          that.$refs.RefMessageData.$refs.input.scrollTop = height;
        }
      })
    },
    Ctrl_Enter_MessageData() {
      let that = this;
      that.point = that.$refs.RefMessageData.$refs.input.selectionStart;
      let _point = (that.$refs.RefMessageData.$refs.input.selectionStart - 1);
      if (that.messageData.length > 0) {
        that.messageData = that.messageData.slice(0, _point + 1) + '\n' + that.messageData.slice(_point + 1);
      }
      else {
        that.messageData += '\n';
      }
      that.$nextTick(() => {
        that.$refs.RefMessageData.$refs.input.selectionStart = _point + 2;
        that.$refs.RefMessageData.$refs.input.selectionEnd = _point + 2;
        if (that.$refs.RefMessageData.$refs.input &&
          that.$refs.RefMessageData.$refs.input.selectionStart >= that.messageData.length
        ) {
          const height = that.$refs.RefMessageData.$refs.input.scrollHeight
          that.$refs.RefMessageData.$refs.input.scrollTop = height;
        }
      })
    },
    Chang_History() {
      var that = this;
      // stop voice
      if (that.TimeOutStop != null) {

        clearTimeout(that.TimeOutStop);
        that.TimeOutStop = null;
      }

      if (that.SpeechRecognizer != null) {

        that.listMessage.pop();

        that.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
      //

      // stop File
      if (that.Axios_ControllerAduio != null) {
        that.Axios_ControllerAduio.abort();
      }
      // strp Open ai
      if (that.Axios_Controller != null) {
        that.Axios_Controller.abort();
      }
      that.Stop_Flag = true;
      if (that.listMessage.length > 0 &&
        that.listMessage[that.listMessage.length - 1].messageBot.length < that.messageRes.length) {

        that.listMessage[that.listMessage.length - 1].messageBot = that.messageRes;

      }
      that.CountScroll = that.MaxCountScroll;
      that.messageData = "";

      that.messageRes = "";
      that.Count_messageRes = 0;
      that.StatusPro = false;

    },
    StopMessage() {
      let that = this;
      if (that.listMessage.length == 0 ||
        (that.listMessage.length > 0 && (
          that.listMessage[that.listMessage.length - 1].status_Process == 'Stop' ||
          that.listMessage[that.listMessage.length - 1].status_Process == 'END' ||
          that.listMessage[that.listMessage.length - 1].status_Process == 'Error')
        )
      ) {
        return;
      }
      // stop Text_Run 
      if (that.TimeOutText_Run != null) {

        clearTimeout(that.TimeOutText_Run);
        that.TimeOutText_Run = null;
      }
      // stop voice
      if (that.TimeOutStop != null) {
        clearTimeout(that.TimeOutStop);
        that.TimeOutStop = null;
      }
      if (that.SpeechRecognizer != null) {

        that.listMessage.pop();

        that.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
      // stop File
      if (that.Axios_ControllerAduio != null) {
        that.Axios_ControllerAduio.abort();
      }
      // strp Open ai
      if (that.Axios_Controller != null) {
        that.Axios_Controller.abort();
      }
      that.Stop_Flag = true;
      if (that.listMessage.length > 0 &&
        that.listMessage[that.listMessage.length - 1].messageBot.length < that.messageRes.length) {
        that.listMessage[that.listMessage.length - 1].messageBot = that.messageRes;
      }
      if (that.listMessage.length > 0 &&
        that.listMessage[that.listMessage.length - 1].status_Process == 'END'
        && that.listMessage[that.listMessage.length - 1].messageBot != null
        && that.listMessage[that.listMessage.length - 1].messageBot.length < that.messageRes.length) {
        that.Count_messageRes = 0;
        that.StatusPro = true;
        that.loading = true;
        that.messageRun = "";
        that.listMessage[that.listMessage.length - 1].messageBot = that.messageRes;
        that.messageRes = "";

        setTimeout(() => {
          that.CountScroll = that.MaxCountScroll;
          that.ChatRef_ScrollIntoView();
        }, 5);
        return;
      }
      if (that.listMessage.length > 0) {
        that.listMessage[that.listMessage.length - 1].status_Process = "Stop";
      }
      that.listMessage[that.listMessage.length - 1].messageBot = that.listMessage[that.listMessage.length - 1].messageBot.replace('', '');
      that.messageData = "";
      that.messageRes = "";
      that.Count_messageRes = 0;
      that.StatusPro = false;
    },

    Clear_listMessage() {
      var that = this;
      if (that.listMessage.length == 0 || (that.listMessage.length > 0 &&
        (that.listMessage[that.listMessage.length - 1].status_Process == 'Process' ||
          that.listMessage[that.listMessage.length - 1].status_Process == 'Send_Message' ||
          that.listMessage[that.listMessage.length - 1].status_Process == 'VoiceStart'))) {
        return;
      }
      let dataPost = {
        "events": [
          {
            "replyToken": "dummyToken",
            "type": "message",
            "timestamp": 1462629479859,
            "source": {
              "type": "user",
              "userId": that.User_Id
            },
            "message": {
              "id": "325708",
              "type": "text",
              "topicModelID": that.TopicModelID_long,
              "topicID": that.Log_History_TopicID,
              "keyTopic": that.KeyTopic,
              "text": ":clearmemory"
            }
          }
        ]
      };
      let Config = {
        onUploadProgress: () => {
          console.log("onUploadProgress");
        },
        onDownloadProgress: () => {
          console.log("onDownloadProgress");

        },

        maxRedirects: 0 // avoid buffering the entire stream
      }
      if (that.snippet_StatusLocal != true) {
        that.$call.GptFullStreamPOST(dataPost, Config, () => {
          that.listMessage = [];
          that.messageData = "";
          that.messageRes = "";
          that.Count_messageRes = 0;
          that.StatusPro = false;
        },
          () => {
          });
      }
      else {
        that.$call.GptFullStreamPostToken(dataPost, Config, that.auth_token, () => {
          that.listMessage = [];
          that.messageData = "";
          that.messageRes = "";
          that.Count_messageRes = 0;
          that.StatusPro = false;
        },
          () => {
          });
      }
    },

    Keydown_Enter_MessageData() {
    },
    ChatRef_ScrollIntoView() {
      let that = this;
      if (that.$refs.ChatScreRef && that.CountScroll >= that.MaxCountScroll &&
        Math.round(that.$refs.ChatScreRef.scrollTop + that.$refs.ChatScreRef.clientHeight) <= that.$refs.ChatScreRef.scrollHeight) {
        that.$refs.ChatRef.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
        that.CountScroll = 0;
      }
      that.CountScroll++;
    },
    SendOpenAi(K_in) {
      let that = this;
      that.GetDateTime()
      if (that.listMessage.length > 0 &&
        that.listMessage[that.listMessage.length - 1].status_Process == 'END'
        && that.listMessage[that.listMessage.length - 1].messageBot != null
        && that.listMessage[that.listMessage.length - 1].messageBot.length < that.messageRes.length) {
        that.Count_messageRes = 0;
        that.StatusPro = true;
        that.loading = true;
        that.messageRun = "";
        that.listMessage[that.listMessage.length - 1].messageBot = that.messageRes;
        that.messageRes = "";
        setTimeout(() => {
          that.CountScroll = that.MaxCountScroll;
          that.ChatRef_ScrollIntoView();
        }, 5);
        if (that.messageData == "") {
          return;
        }
      }
      if (that.messageData == "" || (that.listMessage.length > 0 &&
        (that.listMessage[that.listMessage.length - 1].status_Process != 'END'
          && that.listMessage[that.listMessage.length - 1].status_Process != 'Error'
          && that.listMessage[that.listMessage.length - 1].status_Process != 'Stop'))) {
        return;
      }
      let _messageData = that.messageData;
      that.messageData = "";
      that.loading = true;
      that.listMessage.push({
        messageUser: _messageData,
        messageBot: '',
        status_Process: 'Process',
        requestTime: that.today,
        responseTime: null,
        status: null,
        comment: '',
        commentDialog: false,
        moreComment: false,
      }
      )
      setTimeout(() => {
        that.CountScroll = that.MaxCountScroll;
        that.ChatRef_ScrollIntoView();
      }, 5);
      if (that.KeyTopic == null || that.KeyTopic == "" || that.Log_History_TopicID == -1) {
        that.KeyTopic = that.GetUuidv4_Fun();
      }
      if (that.listTopic.length > 0 && that.listTopic[0].topicID == -1) {
        that.listTopic[0].topicName = _messageData;
        that.listTopic[0].keyTopic = that.KeyTopic;
      }
      let tempModelID = parseInt(that.modelDisplayID) || null;
      let dataPost = {
        "events": [
          {
            "replyToken": "dummyToken",
            "type": "message",
            "timestamp": 1462629479859,
            "fullStream": true,
            "stream": false,
            "snippet": that.snipet_flag ?? false,
            "source": {
              "type": "users",
              "userId": that.User_Id,
              "groupModel": that.parameterURL.groupmodel,
              "domainName": that.URL_Domain,
              "modelDisplayID": tempModelID,
              "tokenParam": that.tokenParam,


            },

            "message": {
              "id": "325708",
              "type": "text",
              "topicModelID": that.TopicModelID_long,
              "topicID": that.Log_History_TopicID,
              "keyTopic": that.KeyTopic,
              "text": _messageData,
              "productSelect": self.productsSelect,
            },
            "PersonalInfoToken": that.personalInfoToken,
          }
        ]
      };
      that.Stop_Flag = false;
      that.messageRes = "";
      that.Count_messageRes = 0;
      that.StatusPro = true;
      that.loading = true;
      that.messageRun = "";
      that.Axios_Controller = new AbortController();

      let Config = {
        signal: that.Axios_Controller.signal,
        onUploadProgress: () => {
          that.Text_Run();
          if (that.listMessage[that.listMessage.length - 1].messageBot == "") {
            try {
            } catch {
            }
          }
        },
        onDownloadProgress: progressEvent => {
          const xhr = (progressEvent.target == undefined ? progressEvent.event.target : progressEvent.target);
          try {
            if (that.listMessage[that.listMessage.length - 1].messageBot == "" || that.listMessage[that.listMessage.length - 1].messageBot == '') {

              try {
                that.GetTopicStream("Steam");
              } catch {
              }
            }
            that.GetDateTime()
            const { responseText } = xhr
            that.listMessage[that.listMessage.length - 1].status_Process = "Send_Message";
            that.listMessage[that.listMessage.length - 1].responseTime = that.today;

            let _responseText = responseText.replaceAll("data: [DONE]", "");
            if(_responseText.indexOf("|Products|[") != -1){
              var tempJson = _responseText.split("|Products|");
              _responseText = tempJson[0];
              self.products = JSON.parse(tempJson[1]);
              this.hideProducts = false;
            }

            /* eslint-disable */


            _responseText = _responseText.replace(/(?:\\\\n|\\\n|\\n|\r\n|\r|\n)/g, "\n");


            _responseText = _responseText.replace(/(?:      \n|     \n|    \n|   \n|  \n| \n)/g, "\n");
            _responseText = _responseText.replace(/(?:\n      ```|\n     ```|\n    ```|\n   ```|\n  ```|\n ```)/g, "\n```");

            _responseText = _responseText.replace(/(?:\n```\n```\n\n)/g, "\n<||End||>\n<||EndMarkdown||>\n\n");
            _responseText = _responseText.replace(/(?:\n```\n\n)/g, "\n<||End||>\n\n");

            _responseText = _responseText.replace(/(?:\n```\n```python|\n   ```\n   ```python)/g, "\n<||StarMarkdown||>\n<||StarPython||>");
            _responseText = _responseText.replace(/(?:\n```\n```javascript|\n   ```\n   ```javascript)/g, "\n<||StarMarkdown||>\n<||StarJavascript||>");

            _responseText = _responseText.replace(/(?:\n```\n)/g, "\n<||StarAll||>\n");
            _responseText = _responseText.replace(/(?:\n```python)/g, "\n<||StarPython||>");
            _responseText = _responseText.replace(/(?:\n```javascript)/g, "\n<||StarJavascript||>");
            _responseText = _responseText.replace(/(?:\n```markdown)/g, "\n<||StarMarkdown||>");

            let Sp_RT = _responseText.split("<||");


            for (let I_Sp_RT = 0; I_Sp_RT < Sp_RT.length; I_Sp_RT++) {

              let Sp_Value = Sp_RT[I_Sp_RT].split("||>");
              if (I_Sp_RT >= 1 && Sp_Value.length > 1) {


                let Sp_Value_Old = Sp_RT[I_Sp_RT - 1].split("||>");
                if (Sp_Value[0].indexOf("End") != -1) {

                  for (let II_Sp_RT = I_Sp_RT - 1; II_Sp_RT > 0; II_Sp_RT--) {

                    try {

                      let Sp_Value_Old_Loop = Sp_RT[II_Sp_RT].split("||>");
                      if (Sp_Value_Old.length > 1 && Sp_Value_Old_Loop.length > 1) {

                        let x = 0;

                        if (Sp_Value[0].indexOf("End") != -1 && Sp_Value_Old[0].indexOf("Star") != -1) {
                          let re_SVO = Sp_Value_Old[0].replace("Star", "End");
                          Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace("End||>", re_SVO + "||>");
                          break;
                        }
                        else if (Sp_Value[0].indexOf("End") != -1 && Sp_Value_Old[0].indexOf("End") != -1
                          && Sp_Value_Old_Loop[0].indexOf("Star") != -1 &&
                          Sp_Value_Old_Loop[0].indexOf(Sp_Value_Old[0].replace("End", "Star")) == -1
                        ) {
                          let re_SVO = Sp_Value_Old_Loop[0].replace("Star", "End");
                          Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace("End||>", re_SVO + "||>");
                          break;
                        }
                        else {
                          let dd = 0;
                        }
                      }
                    } catch (e) {
                      // let ddd = 0;
                    }
                  }
                }
                else if (((I_Sp_RT + 1) < Sp_RT.length) && Sp_Value[0].indexOf("StarAll") != -1) {
                  let Sp_Value_New = Sp_RT[I_Sp_RT + 1].split("||>");
                  if (Sp_Value_Old[0].indexOf("Star") != -1
                    && Sp_Value_New.length > 1 && Sp_Value_New[0].indexOf("Star") != -1) {
                    let re_SVO = Sp_Value_Old[0].replace("Star", "End");
                    Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace("StarAll||>", re_SVO + "||>");
                  }
                }
              }
              if (I_Sp_RT == Sp_RT.length - 1) {
                for (let Iii_Sp_RT = 0; Iii_Sp_RT < Sp_RT.length; Iii_Sp_RT++) {
                  if (Sp_RT[Iii_Sp_RT].indexOf("||>") != -1) {
                    Sp_RT[Iii_Sp_RT] = "<||" + Sp_RT[Iii_Sp_RT];
                  }
                }
                _responseText = Sp_RT.join("");
              }
              _responseText = _responseText.replaceAll("<||StarMarkdown||>", "\n`````\n");
              _responseText = _responseText.replaceAll("<||EndMarkdown||>", "`````\n");

              _responseText = _responseText.replaceAll("<||StarAll||>", "```");
              _responseText = _responseText.replaceAll("<||EndAll||>", "```");


              _responseText = _responseText.replaceAll("<||StarJavascript||>", "```javascript");
              _responseText = _responseText.replaceAll("<||EndJavascript||>", "```");
              _responseText = _responseText.replaceAll("<||StarPython||>", "```python");
              _responseText = _responseText.replaceAll("<||EndPython||>", "```");


              _responseText = _responseText.replaceAll("<||Star||>", "```");
              _responseText = _responseText.replaceAll("<||End||>", "```");

            }



            _responseText = _responseText.replace(/(?:\\n\\n|\n\n)/g, "\n");
            // _responseText = _responseText.replace(/(?:\\\```|\\```)/g, "\\```");
            _responseText = _responseText.replace(/(?:\\\```|\\```|\```)/g, "<||TextMarkdown||>");

            _responseText = _responseText.replace(/(?:\\\`|\\`)/g, "\\`");

            _responseText = _responseText.replaceAll("<||TextMarkdown||>", "\```");


            // _responseText = _responseText.replaceAll(" '", " '");

            _responseText = _responseText.replaceAll("(```", "(\\```");
            _responseText = _responseText.replaceAll("(``", "(\\``");
            _responseText = _responseText.replaceAll("(`", "(\\`");
            _responseText = _responseText.replaceAll("` ` `", "`` ` ``");





            if (_responseText.indexOf("<!DOCTYPE html>") == 0 && _responseText.indexOf("```html\n<!DOCTYPE html>") == -1
              && _responseText.indexOf("```\n<!DOCTYPE html>") == -1 && _responseText.indexOf("<style>" != -1)) {

              let Sp_responseTextStart = _responseText.split("<style>");
              let Sp_responseTextEnd = Sp_responseTextStart[1].split("</style>");


              if (Sp_responseTextEnd.length > 0) {

                Sp_responseTextEnd[0] = Sp_responseTextEnd[0].replaceAll("}\n", "}\n  #V_markDown ");

              }

              _responseText = Sp_responseTextStart[0] + "<style> #V_markDown " + Sp_responseTextEnd[0] +
                (Sp_responseTextEnd.length > 1 ? " </style> " + Sp_responseTextEnd[1] : "")

            }
            if (_responseText.indexOf("|Text|*Streaming:true*|") != -1) {
              _responseText = _responseText.replaceAll("|Text|*Streaming:true*|", "");
              that.listMessage[that.listMessage.length - 1].messageBot = _responseText;
              that.messageRes = _responseText;
              that.messageRes = "";
              that.Count_messageRes = 0;
              that.StatusPro = false;
            }
            else if (_responseText.indexOf("|Text|*Streaming:false*|") != -1) {
              _responseText = _responseText.replaceAll("|Text|*Streaming:false*|", "");
              that.listMessage[that.listMessage.length - 1].messageBot = _responseText;
              that.messageRes = _responseText;
              that.messageRes = "";
              that.Count_messageRes = 0;
              that.StatusPro = false;
            }
            else {
              that.messageRes = _responseText;
              that.StatusPro = true;
            }
          } catch (e) {
            console.log("e")
          }
        },
        maxRedirects: 0 // avoid buffering the entire stream
      }
      if (that.snippet_StatusLocal != true) {
        that.$call.GptFullStreamPOST(dataPost, Config, () => {
          if(that.listMessage[that.listMessage.length - 1].messageBot == "**#Personal Information**") //that.personalInfoToken
          {
            that.listMessage[that.listMessage.length - 1].status_Process = "Process";

            //#region Personal Information
            window.open(`${API_BASE_URL}api/v0/SSO/SignInPersonalInfo`, "Popup", "width=850,height=750");

            const handleMessage = async function (event) {
              try {
                // ตรวจสอบข้อมูลจาก popup
                if (!event.data || !event.data.message) return;

                const data = event.data;
                that.personalInfoToken = data.message;

                let dataPost = {
                  "events": [
                    {
                      "replyToken": "dummyToken",
                      "type": "message",
                      "timestamp": 1462629479859,
                      "fullStream": true,
                      "stream": false,
                      "snippet": that.snipet_flag ?? false,
                      "source": {
                        "type": "users",
                        "userId": that.User_Id,
                        "groupModel": that.parameterURL.groupmodel,
                        "domainName": that.URL_Domain,
                        "modelDisplayID": tempModelID,
                        "tokenParam": that.tokenParam,


                      },

                      "message": {
                        "id": "325708",
                        "type": "text",
                        "topicModelID": that.TopicModelID_long,
                        "topicID": that.Log_History_TopicID,
                        "keyTopic": that.KeyTopic,
                        "text": _messageData,
                        "productSelect": self.productsSelect,
                      },
                      "PersonalInfoToken": that.personalInfoToken,
                    }
                  ]
                };
                that.$call.GptFullStreamPOST(dataPost, Config, () => {
                  that.StatusPro = false;
                  that.successalert = true;
                  // that.listMessage[that.listMessage.length - 1].status_Process = "END";

                  let _User_Id = {
                    TopicID: that.Log_History_TopicID,
                    USER_CHANNEL: that.User_Id,
                    ID: that.Log_History_ID,
                    Take: that.Log_History_Take
                  };
                  that.$call.GetLastLogID(_User_Id,(response)=>{
                      if (response.status == 0) {
                        let response_data = response.data
                        that.listMessage[that.listMessage.length - 1].status_Process = "END";
                        if(that.messageRes != "" && that.messageRes != null && that.messageRes != undefined) {
                          that.listMessage[that.listMessage.length - 1].messageBot = that.messageRes;
                        }
                        that.listMessage[that.listMessage.length - 1].id = response_data.id;
                      }
                    }
                  )
                  setTimeout(() => {
                    that.CountScroll = that.MaxCountScroll;
                    that.ChatRef_ScrollIntoView();
                  }, 5);
                  that.loading = false;
                },
                (_response) => {
                  that.loading = false;
                  that.erroralert = true;
                  if (that.listMessage.length == 0) {
                  }
                  else if (that.Stop_Flag == true && that.listMessage.length > 0) {
                    that.listMessage[that.listMessage.length - 1].status_Process = "Stop";
                  }
                  else {
                    that.StatusPro = false;
                    that.Count_messageRes = 0;
                    that.messageData = "";
                    if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].messageBot.length < that.messageRes.length) {
                      that.listMessage[that.listMessage.length - 1].messageBot = (that.messageRes + "<br />Error something went wrong ...");
                    }
                    else {
                      that.listMessage[that.listMessage.length - 1].messageBot += "Error something went wrong ...";
                    }
                    that.messageRes = "";
                    that.listMessage[that.listMessage.length - 1].status_Process = "Error";
                  }
                  that.Stop_Flag = false;
                  setTimeout(() => {
                    that.CountScroll = that.MaxCountScroll;
                    that.ChatRef_ScrollIntoView();
                  }, 5);
                });

              } catch (error) {
                console.log("🐞 ใน handleMessage:", error);
              } finally {
                console.log("🛑 EventListener message snippet_Status: ", that.snippet_Status);
                window.removeEventListener('message', handleMessage);
              }
            };

            console.log("🧱 EventListener message snippet_Status: ", that.snippet_Status);
            window.addEventListener('message', handleMessage);
            // #endregion Personal Information

          }
          else
          {
            that.StatusPro = false;
            that.successalert = true;
            // that.listMessage[that.listMessage.length - 1].status_Process = "END";

            let _User_Id = {
              TopicID: that.Log_History_TopicID,
              USER_CHANNEL: that.User_Id,
              ID: that.Log_History_ID,
              Take: that.Log_History_Take
            };
            that.$call.GetLastLogID(_User_Id, (response) => {
              if (response.status == 0) {
                let response_data = response.data
                that.listMessage[that.listMessage.length - 1].status_Process = "END";
                that.listMessage[that.listMessage.length - 1].id = response_data.id;
              }
            }
            )
            setTimeout(() => {
              that.CountScroll = that.MaxCountScroll;
              that.ChatRef_ScrollIntoView();
            }, 5);
            that.loading = false;
          }
        },
          (_response) => {
            console.log("catch");
            that.loading = false;
            that.erroralert = true;
            if (that.listMessage.length == 0) {
            }
            else if (that.Stop_Flag == true && that.listMessage.length > 0) {
              that.listMessage[that.listMessage.length - 1].status_Process = "Stop";
            }
            else {
              that.StatusPro = false;
              that.Count_messageRes = 0;
              that.messageData = "";
              if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].messageBot.length < that.messageRes.length) {
                that.listMessage[that.listMessage.length - 1].messageBot = (that.messageRes + "<br />Error something went wrong ...");
              }
              else {
                that.listMessage[that.listMessage.length - 1].messageBot += "Error something went wrong ...";
              }
              that.messageRes = "";
              that.listMessage[that.listMessage.length - 1].status_Process = "Error";
            }
            that.Stop_Flag = false;
            console.log("Error : " + _response);
            setTimeout(() => {
              that.CountScroll = that.MaxCountScroll;
              that.ChatRef_ScrollIntoView();
            }, 5);
          });
      }
      else {
        that.$call.GptFullStreamPostToken(dataPost, Config, that.auth_token, () => {
          if(that.listMessage[that.listMessage.length - 1].messageBot == "**#Personal Information**")
          {
            that.listMessage[that.listMessage.length - 1].status_Process = "Process";

            //#region Personal Information
            window.open(`${API_BASE_URL}api/v0/SSO/SignInPersonalInfo`, "Popup", "width=850,height=750");

            const handleMessage = async function (event) {
              try {
                // ตรวจสอบข้อมูลจาก popup
                if (!event.data || !event.data.message) return;

                const data = event.data;
                that.personalInfoToken = data.message;
                let dataPost = {
                  "events": [
                    {
                      "replyToken": "dummyToken",
                      "type": "message",
                      "timestamp": 1462629479859,
                      "fullStream": true,
                      "stream": false,
                      "snippet": that.snipet_flag ?? false,
                      "source": {
                        "type": "users",
                        "userId": that.User_Id,
                        "groupModel": that.parameterURL.groupmodel,
                        "domainName": that.URL_Domain,
                        "modelDisplayID": tempModelID,
                        "tokenParam": that.tokenParam,


                      },

                      "message": {
                        "id": "325708",
                        "type": "text",
                        "topicModelID": that.TopicModelID_long,
                        "topicID": that.Log_History_TopicID,
                        "keyTopic": that.KeyTopic,
                        "text": _messageData
                      },
                      "PersonalInfoToken": that.personalInfoToken,
                    }
                  ]
                };

                that.$call.GptFullStreamPostToken(dataPost, Config, that.auth_token,() => {
                that.StatusPro = false;
                that.successalert = true;

                if(that.messageRes != "" && that.messageRes != null && that.messageRes != undefined) {
                  that.listMessage[that.listMessage.length - 1].messageBot = that.messageRes;
                }
                that.listMessage[that.listMessage.length - 1].status_Process = "END";
                setTimeout(() => {
                  that.CountScroll = that.MaxCountScroll;
                  that.ChatRef_ScrollIntoView();
                }, 5);
                that.loading = false;
                },
                (_response) => {
                  that.loading = false;
                  that.erroralert = true;
                  if (that.listMessage.length == 0) {
                  }
                  else if (that.Stop_Flag == true && that.listMessage.length > 0) {
                    that.listMessage[that.listMessage.length - 1].status_Process = "Stop";
                  }
                  else {
                    that.StatusPro = false;
                    that.Count_messageRes = 0;
                    that.messageData = "";
                    if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].messageBot.length < that.messageRes.length) {
                      that.listMessage[that.listMessage.length - 1].messageBot = (that.messageRes + "<br />Error something went wrong ...");
                    }
                    else {
                      that.listMessage[that.listMessage.length - 1].messageBot += "Error something went wrong ...";
                    }
                    that.messageRes = "";
                    that.listMessage[that.listMessage.length - 1].status_Process = "Error";
                  }
                  that.Stop_Flag = false;
                  setTimeout(() => {
                    that.CountScroll = that.MaxCountScroll;
                    that.ChatRef_ScrollIntoView();
                  }, 5);
                });

              } catch (error) {
                console.log("🐞 ใน handleMessage:", error);
              } finally {
                console.log("🛑 EventListener message snippet_Status: ", that.snippet_Status);
                window.removeEventListener('message', handleMessage);
              }
            };

            console.log("🧱 EventListener message snippet_Status: ", that.snippet_Status);
            window.addEventListener('message', handleMessage);
            // #endregion Personal Information
          }
          else
          {
            that.StatusPro = false;
            that.successalert = true;
            that.listMessage[that.listMessage.length - 1].status_Process = "END";
            setTimeout(() => {
              that.CountScroll = that.MaxCountScroll;
              that.ChatRef_ScrollIntoView();
            }, 5);
            that.loading = false;
          }
          
        },
          (_response) => {
            that.loading = false;
            that.erroralert = true;
            if (that.listMessage.length == 0) {
            }
            else if (that.Stop_Flag == true && that.listMessage.length > 0) {
              that.listMessage[that.listMessage.length - 1].status_Process = "Stop";
            }
            else {
              that.StatusPro = false;
              that.Count_messageRes = 0;
              that.messageData = "";
              if (that.listMessage.length > 0 && that.listMessage[that.listMessage.length - 1].messageBot.length < that.messageRes.length) {
                that.listMessage[that.listMessage.length - 1].messageBot = (that.messageRes + "<br />Error something went wrong ...");
              }
              else {
                that.listMessage[that.listMessage.length - 1].messageBot += "Error something went wrong ...";
              }
              that.messageRes = "";
              that.listMessage[that.listMessage.length - 1].status_Process = "Error";
            }
            that.Stop_Flag = false;
            setTimeout(() => {
              that.CountScroll = that.MaxCountScroll;
              that.ChatRef_ScrollIntoView();
            }, 5);
          });
      }
      that.loading = false;
    },


    Text_Run() {

      let that = this;

      that.TimeOutText_Run = setTimeout(() => {

        if (that.listMessage.length == 0) {
          that.StopMessage();
          return;
        }

        if (that.Count_messageRes >= that.messageRes.length && that.StatusPro == false) {
          setTimeout(() => {
            that.CountScroll = that.MaxCountScroll;
            that.ChatRef_ScrollIntoView();
          }, 5);
        }

        // console.log("ss")
        if (that.Count_messageRes < that.messageRes.length || that.StatusPro == true) {


          if (that.listMessage[that.listMessage.length - 1].messageBot.length > 0 && that.listMessage[that.listMessage.length - 1].messageBot.substring(that.listMessage[that.listMessage.length - 1].messageBot.length - 47, that.listMessage[that.listMessage.length - 1].messageBot.length) == '') {

            that.listMessage[that.listMessage.length - 1].messageBot = that.listMessage[that.listMessage.length - 1].messageBot.substring(0, that.listMessage[that.listMessage.length - 1].messageBot.length - 47);
          }




          if (that.Count_messageRes < that.messageRes.length) {
            // that.messageRun += that.messageRes[that.Count_messageRes];

            if (that.messageRes.length > (that.Count_messageRes + 5) && that.messageRes[that.Count_messageRes] == "<") {

              if (that.messageRes[that.Count_messageRes] + that.messageRes[that.Count_messageRes + 1] + that.messageRes[that.Count_messageRes + 2]
                + that.messageRes[that.Count_messageRes + 3] + that.messageRes[that.Count_messageRes + 4] + that.messageRes[that.Count_messageRes + 5]
                == "<br />") {

                that.listMessage[that.listMessage.length - 1].messageBot += "<br />";
                that.Count_messageRes += 5;
              }
              else if (that.messageRes[that.Count_messageRes] == "<") {

                that.listMessage[that.listMessage.length - 1].messageBot += that.messageRes[that.Count_messageRes];
              }
              else {
                that.listMessage[that.listMessage.length - 1].messageBot += that.messageRes[that.Count_messageRes];
              }


            } else if ((that.messageRes[that.Count_messageRes] + that.messageRes[that.Count_messageRes + 1] + that.messageRes[that.Count_messageRes + 2]
              + that.messageRes[that.Count_messageRes + 3] + that.messageRes[that.Count_messageRes + 4] + that.messageRes[that.Count_messageRes + 5]
              + that.messageRes[that.Count_messageRes + 6] + that.messageRes[that.Count_messageRes + 7] == "![Image]") || that.messageImage != "") {
              let count = 0;
              for (let index = that.Count_messageRes; index < that.messageRes.length; index++) {
                const element = that.messageRes[index];
                that.messageImage += element;
                count++;
                if (element == ")") {
                  break;
                }
              }
              if (that.messageRes[that.Count_messageRes + (count - 1)] == ")") {
                that.listMessage[that.listMessage.length - 1].messageBot += that.messageImage;
                that.messageImage = "";
              }
              that.Count_messageRes += count - 1;
            }
            else {
              that.listMessage[that.listMessage.length - 1].messageBot += that.messageRes[that.Count_messageRes];
              that.messageImage = "";
            }


            that.Count_messageRes++;
            that.ChatRef_ScrollIntoView();
            // console.log(that.messageRes[that.Count_messageRes])
          }


          that.listMessage[that.listMessage.length - 1].messageBot += ``;


          if (that.Count_messageRes == that.messageRes.length && that.listMessage[that.listMessage.length - 1].status_Process == "END") {

            //  that.listMessage[that.listMessage.length - 1].status_Process = "END";


            if (that.listMessage[that.listMessage.length - 1].messageBot.length > 0 && that.listMessage[that.listMessage.length - 1].messageBot.substring(that.listMessage[that.listMessage.length - 1].messageBot.length - 47, that.listMessage[that.listMessage.length - 1].messageBot.length) == '') {

              that.listMessage[that.listMessage.length - 1].messageBot = that.listMessage[that.listMessage.length - 1].messageBot.substring(0, that.listMessage[that.listMessage.length - 1].messageBot.length - 47);
            }
          }


          that.Text_Run();
        }

      }, that.Time_Delay);

    },

    CHK_Auth_Token() {
      let that = this;

      /*
            that.axios
              .post(`${that.url}api/v0/GPTStream/ChkTokenFullStream`, { auth_token: that.auth_token })
              .then(function (response) {
                if (response.status == 200 && response.data.status == 0 && response.data.data == true) {
      
                  that.Status_Error = false;
                }
                else {
      
                  that.Status_Error = true;
                  that.Text_Status = "ไม่พบ Auth";
                }
              })
              .catch(function () {
      
                that.Status_Error = true;
                that.Text_Status = "ไม่พบ Auth";
              });
              */




      try {
        let _auth_token = { auth_token: that.auth_token };
        that.auth_token = "";
        that.$call.ChkTokenFullStream(_auth_token, (response) => {

          if (response.status == 0 && response.data.chk) {
            that.Time_Delay = response.data.timeDelay;
            that.maximumChatInput = 200000;
            that.Status_Error = false;
          }
          else {

            that.Status_Error = true;
            that.Text_Status = "ไม่พบ Auth";
          }
        },
          () => {
            that.Status_Error = true;
            that.Text_Status = "ไม่พบ Auth";
          }
        );
      }
      catch {
        that.Status_Error = true;
        that.Text_Status = "ไม่พบ Auth";
      }


    },

    GetHistoryFullStream(Status) {
      var that = this;
      if (that.Loading_History_Status == true) {
        return;
      }
      try {
        let _User_Id = {
          TopicID: that.Log_History_TopicID,
          USER_CHANNEL: that.User_Id,
          ID: that.Log_History_ID,
          Take: that.Log_History_Take
        };

        that.Loading_History_Status = true;
        that.$call.GetHistoryFullStream(_User_Id, that.auth_token, (response) => {

          if (response.status == 0) {
            let response_data = response.data
            const thisData = response_data.map((v) => ({
              ...v,
              comment: '',
              commentDialog: false,
              moreComment: false,
              feedback: null,
              status: null
            }));

            if (Status == "Start") {
              that.listMessage = thisData;
              that.SetButtom_Page();
            }
            else if (Status == "ScrollUp") {
              if (!(that.listMessage.length > 0 && that.listMessage[0].id == undefined)) {

                that.listMessage = thisData.concat(that.listMessage);
              } else {
                that.flagTopHistory = false;
              }

              if (that.flagTopHistory) {
                setTimeout(() => {
                  var element1 = document.getElementById("ChatId_" + that.Log_History_ID);
                  if (element1 != undefined && element1 != null) {
                    that.$refs.ChatScreRef.scrollTop = element1.offsetTop - 20;
                  }
                  that.Loading_History_Status = false;
                }, 1);
              }
            }
            thisData.map(() => { that.messageRes.push("") });
          }
          that.Loading_History_Status = false;
        },
          () => {
            that.Loading_History_Status = false;
            console.log('GetHistoryFullStream : false')
          }
        );
      }
      catch {
        // that.listMessage = [];

      }


    },
    GetHistoryStream(Status) {
      var that = this;


      if (that.Loading_History_Status == true) {
        return;
      }
      try {


        let _User_Id = {
          TopicID: that.Log_History_TopicID,
          USER_CHANNEL: that.User_Id,
          ID: that.Log_History_ID,
          Take: that.Log_History_Take
        };

        that.Loading_History_Status = true;
        that.$call.GetHistoryStream(_User_Id, (response) => {

          if (response.status == 0) {

            // that.listMessage = response.data;
            let response_data = response.data

            const thisData = response_data.map((v) => ({
              ...v,
              comment: '',
              commentDialog: false,
              moreComment: false,
              feedback: null,
              status: null
            }));

            // that.listMessage = response_data.concat(that.listMessage);
            if (Status == "Start") {
              // that.listMessage = response_data;
              that.listMessage = thisData;
              that.SetButtom_Page();
            }
            else if (Status == "ScrollUp") {
              //  that.listMessage = response_data.concat(that.listMessage); 

              if (!(that.listMessage.length > 0 && that.listMessage[0].id == undefined)) {

                that.listMessage = thisData.concat(that.listMessage);
              }


              setTimeout(() => {
                // var element = document.getElementById("ChatId_2");
                var element1 = document.getElementById("ChatId_" + that.Log_History_ID);
                if (element1 != undefined && element1 != null) {
                  that.$refs.ChatScreRef.scrollTop = element1.offsetTop - 20;
                }
                that.Loading_History_Status = false;
              }, 1);
            }
          }
          else {
            // that.listMessage = [];
          }


          // setTimeout(() => {
          that.Loading_History_Status = false;
          // }, 1000);

        },
          () => {

            // setTimeout(() => {
            that.Loading_History_Status = false;
            // }, 1000);

            // that.listMessage = [];
            console.log('GetHistoryStream : false')
          }
        );
      }
      catch {
        // that.listMessage = [];

      }


    },


    GetTopicStream(status) {
      var that = this;

      try {


        let _User_Id = {
          USER_CHANNEL: that.User_Id
        };

        that.$call.GetTopicStreamToken(_User_Id, that.auth_token, (response) => {

          if (response.status == 0 && _User_Id.USER_CHANNEL == that.User_Id) {

            // that.listMessage = response.data;
            let response_data = response.data
            that.maximumChatInput = response_data[0].maximumChatInput;
            if (that.listMessage.length > 0) {
              if (([':model'].some(keyword => that.listMessage[that.listMessage.length - 1].messageUser.toLowerCase().includes(keyword.toLowerCase())))) {
                that.Time_Delay = response_data[0].timeDelay;
              }
            } else {
              that.Time_Delay = response_data[0].timeDelay;
            }
            // that.listMessage = response_data.concat(that.listMessage);

            that.listTopic = response_data;

            if (status != "Steam") {

              if (status == "Start") {

                if (response_data.length > 0) {
                  that.Log_History_TopicID = response_data[0].topicID;
                  that.TopicName = response_data[0].topicName;

                  that.TopicModelID = response_data[0].topicModelID;

                  if (response_data[0].topicModelID_long != null) {
                    that.TopicModelID_long = response_data[0].topicModelID_long;
                  }


                  that.KeyTopic = response_data[0].keyTopic;

                  that.ModelFirst = response_data[0].topicModelID;
                }
                else {
                  that.GetModelFirst(that.parameterURL.groupmodel, that.User_Id);
                }
              }


              that.GetHistoryFullStream("Start");
            }
            else {
              if (response_data.length > 0) {
                that.Log_History_TopicID = response_data[0].topicID;
                that.TopicName = response_data[0].topicName;

                that.TopicModelID = response_data[0].topicModelID;

                if (response_data[0].topicModelID_long != null) {
                  that.TopicModelID_long = response_data[0].topicModelID_long;
                }

                that.KeyTopic = response_data[0].keyTopic;

                that.ModelFirst = response_data[0].topicModelID;
              }
              else {
                that.GetModelFirst(that.parameterURL.groupmodel, that.User_Id);
                //  that.TopicModelID =that.ModelFirst;
              }
            }
          }
          else {
            // that.listMessage = [];
            that.listTopic = [];

            that.GetModelFirst(that.parameterURL.groupmodel, that.User_Id);
            // that.TopicModelID =that.ModelFirst;
          }



        },
          () => {

            that.GetModelFirst(that.parameterURL.groupmodel, that.User_Id);
            // that.TopicModelID =that.ModelFirst;
            that.listTopic = [];
            console.log('GetTopicStream : false')
          }
        );
      }
      catch {

        that.GetModelFirst(that.parameterURL.groupmodel, that.User_Id);
        that.listTopic = [];

      }


    },
    ChatScreScroll(e) {
      var that = this;

      if (that.$refs.ChatScreRef.scrollTop <= that.LastScrollTop &&
        that.$refs.ChatScreRef.scrollTop == 0 && that.Loading_History_Status == false) {

        if (that.listMessage.length > 0) {


          that.Log_History_ID = that.listMessage[0].id;



          that.GetHistoryFullStream("ScrollUp");


        }
      }
      else {

      }


      that.LastScrollTop = that.$refs.ChatScreRef.scrollTop;


    },

    SetButtom_Page() {
      var that = this;
      setTimeout(() => {
        if (that.$refs.ChatRef) {
          that.$refs.ChatScreRef.scrollTop = that.$refs.ChatRef.offsetTop;
        }
        else {
          that.SetButtom_Page();
        }


      }, 100);
    },

    GetTopicIDStream(_messageData) {
      var that = this;


      try {
        // let _User_Id = { USER_CHANNEL: that.User_Id, messageData: _messageData,KeyTopic :  that.KeyTopic };

        let _User_Id = { USER_CHANNEL: that.User_Id, messageData: _messageData, KeyTopic: that.KeyTopic };

        that.$call.GetTopicIDStream(_User_Id, (response) => {

          if (response.status == 0 && response.data.status == true) {
            let DataLog_Data = response.data.data;

            try {

              if (DataLog_Data != null) {
                that.Log_History_TopicID = DataLog_Data.topicID;
                that.KeyTopic = DataLog_Data.keyTopic;
                that.TopicName = DataLog_Data.topicName;

                that.TopicModelID = DataLog_Data.topicModelID;

                that.TopicModelID_long = DataLog_Data.topicModelID_long;
              }
            }
            catch {
              console.log("replymsg E")
            }
          }
          else {

            console.log('GetTopicIDStream : else')
          }
        },
          () => {


            console.log('GetTopicIDStream : false')
          }
        );
      }
      catch {

        console.log('GetTopicIDStream : GG')
      }


    },

    async GetModelQuickGroupInModelGroupPostToken() {
      var that = this;
      try {
        let _groupmodel = {
          groupmodel: that.parameterURL.groupmodel,
          USER_CHANNEL: that.User_Id
        };
        await that.$call.GetModelQuickGroupInModelGroupPostToken(_groupmodel, that.auth_token, (response) => {
          if (response.status == 0) {
            let DataLog_Data = response.data;
            try {
              that.ModelQuick = DataLog_Data;
            }
            catch {
              console.log("replymsg E")
            }
          }
          else {

            console.log('GetTopicIDStream : else')
          }
        },
          () => {
            console.log('GetTopicIDStream : false')
          }
        );
      }
      catch {
        console.log('GetTopicIDStream : GG')
      }
    },

    Themecolor() {
      this.selectedColor = this.colorThemeChat != null ? `#${this.colorThemeChat}` : '#FFA41E';
    },

    GetDateTime() {
      let month_names_short = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth(); //January is 0!

      // let yyyy = today1.getFullYear();

      let hh = today1.getHours();
      let m = today1.getMinutes();

      if (dd < 10) {
        dd = '0' + dd;
      }
      if (m < 10) {
        m = '0' + m;
      }
      this.today = dd + ' ' + month_names_short[mm] + " " + hh + ":" + m;
    },
    ThisFeedBackResponse(item, status) {
      let self = this;

      this.listMessage = this.listMessage.map((v) => ({
        ...v,
        status: (item.id == v.id ? status : v.status),
        commentDialog: false,
        comment: item.comment,
      }));
      let temp = {
        data: {
          LogID: item.id,
          Comment: item.comment,
          Score: status,
          CreateBy: self.User_Id,
          ModelDisplayID: item.modelDisplayID,
        },
        token: self.auth_token
      }

      self.$call.FeedbackFromClient(temp, (response) => {
        if (response.status == 0) {
          this.listMessage = this.listMessage.map((v) => ({
            ...v,
            commentDialog: false,
            SelectComment: null,
            comment: null,
          }));
        }
        self.closeDialog(item);
      },
        () => {
          this.listMessage = this.listMessage.map((v) => ({
            ...v,
            commentDialog: false,
            SelectComment: null,
            comment: null,
          }));
        }
      );
    },
    openCommentDialog(item, index) {

      this.listMessage = this.listMessage.map((v, _index) => ({
        ...v,
        status: (index == _index ? 0 : v.status),
        commentDialog: (index == _index ? true : false)
      }));

      this.$set(item, 'status', 0);
      this.$set(item, 'commentDialog', true);
    },
    closeDialog(item) {
      // ใช้ this.$set() เพื่อเปลี่ยนแปลงค่า commentDialog เป็น false
      this.$set(item, 'commentDialog', false);
      this.$set(item, 'SelectComment', null);
      this.$set(item, 'comment', null);
    },
    Clipboard(item) {
      let self = this;
      let text = document.createElement('textarea')
      text.value = this.listMessage.find((v) => (item.id == v.id)).messageBot;
      text.focus();
      document.body.appendChild(text);
      text.select();
      document.execCommand('copy');
      text.parentNode.removeChild(text);
    },
    async SetShowModel(val) {
      let self = this;
      self.menuModel = false;
      self.isShowMore = !val;
      await self.SetModel();
      self.AutoOpenMenu = !self.AutoOpenMenu;
    },

    async SetModel() {
      let self = this;
      if (self.isShowMore == true) {
        self.ModelQuick = this.AllModelDB;
      }
      else {
        self.ModelQuick = self.AllModelDB.filter((x) => x.typeModel == 1);
      }
    },

    async SetShowQuickModel() {
      let self = this;
      self.ModelQuick = self.AllModelDB.filter((x) => x.typeModel == 1);
      self.isShowMore = false;
    },
  },
  async mounted() {
    let that = this;
    if (sessionStorage.getItem("Domain") != undefined && sessionStorage.getItem("Domain") != null && sessionStorage.getItem("Domain") != "null") {
      that.URL_Domain = sessionStorage.getItem("Domain");
    }
    if (sessionStorage.getItem("snippet") != undefined && sessionStorage.getItem("snippet") != null) {
      that.snipet_flag = sessionStorage.getItem("snippet");
    }
    if (sessionStorage.getItem("modelID") != undefined && sessionStorage.getItem("modelID") != null && sessionStorage.getItem("modelID") != "null") {
      that.modelDisplayID = sessionStorage.getItem("modelID");
    }
    if (sessionStorage.getItem("userChanel") != undefined && sessionStorage.getItem("userChanel") != null && sessionStorage.getItem("userChanel") != "" && sessionStorage.getItem("userChanel") != "null") {
      that.userChanel = sessionStorage.getItem("userChanel");
    }
    if (sessionStorage.getItem("tokenParam") != undefined && sessionStorage.getItem("tokenParam") != null && sessionStorage.getItem("tokenParam") != "null") {
      that.tokenParam = sessionStorage.getItem("tokenParam");
    }

    that.$nextTick(async function () {
      for (let key in that.$route.query) {
        that.parameterURL[key.toLowerCase()] = that.$route.query[key];
      }

      if (that.parameterURL.snippet != "true") {
        if (that.parameterURL.auth_token == null || that.parameterURL.auth_token == undefined || that.parameterURL.auth_token == "") {
          that.Status_Error = true;
          that.Text_Status = "ไม่พบ token";
          return;
        }
      }
      else {
        if (that.parameterURL.snippet != undefined) {
          let snippet_temp = that.parameterURL.snippet;
          that.snipet_flag = (String(snippet_temp).toLowerCase() === 'true');
          sessionStorage.setItem("snippet", snippet_temp)
        }
        else if (sessionStorage.getItem("snippet") != undefined && sessionStorage.getItem("snippet") != null) {
          that.snipet_flag = sessionStorage.getItem("snippet");
        }
        else {
          sessionStorage.setItem("snippet", false)
        }

        if (that.parameterURL.domainname != undefined) {
          let Domain = that.parameterURL.domainname;
          that.URL_Domain = Domain;
          sessionStorage.setItem("Domain", Domain)
        }
        else if (sessionStorage.getItem("Domain") != undefined && sessionStorage.getItem("Domain") != null) {

          that.URL_Domain = sessionStorage.getItem("Domain");
        }

        if (that.parameterURL.modelid != undefined) {
          let modelDisplayID = that.parameterURL.modelid;
          that.modelDisplayID = modelDisplayID;
          sessionStorage.setItem("modelID", modelDisplayID)
        }
        else if (sessionStorage.getItem("modelID") != undefined && sessionStorage.getItem("modelID") != null && sessionStorage.getItem("modelID") != "") {

          that.modelDisplayID = sessionStorage.getItem("modelID");
        }
        if (that.parameterURL.user_ch != undefined && that.parameterURL.user_ch != null && that.parameterURL.user_ch != "null" && that.parameterURL.user_ch != "") {
          let userChanel = that.parameterURL.user_ch;
          that.userChanel = userChanel;
          sessionStorage.setItem("userChanel", userChanel)
          that.User_Id_Show = userChanel;
        }
        else if (sessionStorage.getItem("userChanel") != undefined && sessionStorage.getItem("userChanel") != null && sessionStorage.getItem("userChanel") != "" && sessionStorage.getItem("userChanel") != "null") {

          that.userChanel = sessionStorage.getItem("userChanel");
          that.User_Id_Show = sessionStorage.getItem("userChanel");
        }

        if (that.parameterURL.chk_token != undefined) {
          let tokenParam = that.parameterURL.chk_token;
          that.tokenParam = tokenParam;
          sessionStorage.setItem("tokenParam", tokenParam)
        }
        else if (sessionStorage.getItem("tokenParam") != undefined && sessionStorage.getItem("tokenParam") != null && sessionStorage.getItem("tokenParam") != "") {

          that.tokenParam = sessionStorage.getItem("tokenParam");
        }

        if (sessionStorage.getItem("token_Snippet") != null || localStorage.getItem("token_Snippet") != null || Cookies.get("token_Snippet") != null) {

          if (sessionStorage.getItem("token_Snippet") != null) {
            that.auth_token = sessionStorage.getItem("token_Snippet");
            that.User_Id = sessionStorage.getItem("email_Snippet");
            //that.User_Id_Show = sessionStorage.getItem("email_Snippet");
            that.username = sessionStorage.getItem("username_Snippet");
            //that.Snippet_Username = sessionStorage.getItem("username_Snippet");
            //Cookies.set('token_Snippet', sessionStorage.getItem("token_Snippet"));
            //Cookies.set('email_Snippet', sessionStorage.getItem("email_Snippet"));
            //Cookies.set('username_Snippet', sessionStorage.getItem("username_Snippet"));
            //Cookies.set('isSnippet', true);

            //alert("sessionStorage", sessionStorage.getItem("username_Snippet"));
            // sessionStorage.removeItem("token");
            // sessionStorage.removeItem("userid");
            // sessionStorage.removeItem("email");
            // sessionStorage.removeItem("username");
          }
          else if (Cookies.get("token_Snippet") != null) {
            that.auth_token = Cookies.get("token_Snippet");
            that.User_Id = Cookies.get("email_Snippet");
            // that.User_Id_Show = Cookies.get("email_Snippet");
            that.username = Cookies.get("username_Snippet");
            // that.Snippet_Username = Cookies.get("username_Snippet");

            // alert("Cookies", Cookies.get("username_Snippet"));
            // Cookies.remove('token_Snippet');
            // Cookies.remove('email_Snippet');
            // Cookies.remove('username_Snippet');
          }
          else if (localStorage.getItem("token_Snippet") != null) {
            that.auth_token = localStorage.getItem("token_Snippet");
            that.User_Id = localStorage.getItem("email_Snippet");
            //that.User_Id_Show = localStorage.getItem("email_Snippet");
            that.username = localStorage.getItem("username_Snippet");
            //that.Snippet_Username = localStorage.getItem("username_Snippet");
            //Cookies.set('token_Snippet', localStorage.getItem("token_Snippet"));
            //Cookies.set('email_Snippet', localStorage.getItem("email_Snippet"));
            //Cookies.set('username_Snippet', localStorage.getItem("username_Snippet"));
            //Cookies.set('isSnippet', true);

            // alert("localStorage", localStorage.getItem("username_Snippet"));
          }

          // that.auth_token = Cookies.get("token_Snippet");
          // that.User_Id = Cookies.get("email_Snippet");
          // that.User_Id_Show = Cookies.get("email_Snippet");
          // that.username = Cookies.get("username_Snippet");
          // that.Snippet_Username = Cookies.get("username_Snippet");

          // Cookies.set('username', sessionStorage.getItem("username"));
          // Cookies.set('email', sessionStorage.getItem("email"));
          // Cookies.set('isSnippet', sessionStorage.getItem("isSnippet"));
          that.GetTopicStream("Start");
          //await that.GeModelQuickGroupInModelGroupPostToken();
        }
        else {
          that.User_Id = "";
          that.User_Id_Show = "";
          that.Snippet_Username = "";
          that.GetUuidAll();
          that.GetCheckAnonymous();
          if (sessionStorage.getItem("userChanel") != undefined && sessionStorage.getItem("userChanel") != null && sessionStorage.getItem("userChanel") != "" && sessionStorage.getItem("userChanel") != "null") {
            that.userChanel = sessionStorage.getItem("userChanel");
            that.User_Id_Show = sessionStorage.getItem("userChanel");
            that.User_Id = sessionStorage.getItem("userChanel");
          }
        }

        let cookies = Cookies.get(); // get all cookies
        // for(let cookie in cookies) {
        //   Cookies.remove(cookie); // remove each cookie
        // }
        that.Status_Error = false;
        that.snippet_StatusLocal = true;
      }
      that.Themecolor();
    });
  },
};



</script>



<style>
@-webkit-keyframes blinker {
  from {
    opacity: 1.0;
  }

  to {
    opacity: 0.0;
  }
}

/* .blink-cursor{ */
.blinking-cursor {
  text-decoration: blink;
  -webkit-animation-name: blinker;
  -webkit-animation-duration: 0.6s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-direction: alternate;
}



.btn_PrivateMemoryDialog_ListFile .col-6 button {
  width: 100%;
}


@media (min-width: 600px) {

  .btn_PrivateMemoryDialog_ListFile .col-sm-6 button,
  .btn_PrivateMemoryDialog_ListFile .col-md-6 button {
    width: 120px;
  }

  .btn_PrivateMemoryDialog_ListFile .row {
    display: inline-flex;
  }
}

.v_data_table_Private_Memory .v-data-table__empty-wrapper td {
  text-align: center;
}

.Cls_Text_field_TopicName {
  /* width: 192px; */
  /* width: 100%;  */
  padding-top: 0px;
  height: 32px;
  z-index: 99999;
  display: flex;
  /* color: white !important; */
}

.Cls_Text_field_TopicName .v-input__slot {

  /* border-color: white !important; */

  background-color: white !important;
  min-height: 32px !important;
}


.Cls_Text_field_TopicName input {
  /* color: white !important; */
  font-size: 15px;
}

.FullStream_Status_Margin {
  position: fixed;
  margin-top: calc(60px);
}

.FullStream_Status_Margin2 {
  /* margin-top: calc(60px + 22px) !important; */
  height: calc(100vh - 112px);
}

.Snippet_Status_Margin {

  /* margin-top: 55px !important; */
  height: 100% !important
}


.Snippet_Status_Margin #Col_Snippet {
  margin-bottom: 0px !important;
}

.Snippet_Status_Margin #D_MessageData {
  /* max-height: 83px !important;
  height: 45px !important; */
  max-height: 83px !important;
  /* height: 60px !important; */
  font-size: 12px;
  margin-bottom: 12px;
}

textarea#D_MessageData {
  /* max-height: 15vh !important; */
  padding: 0.5%;
  overflow-y: auto;
  max-height: 45vh !important;
  margin-top: 6px !important;
  /* max-height: calc(20vh - 56px)!important; */
}

@media (max-width: 980px) {
  textarea#D_MessageData {
    padding: 0.5%;
    overflow-y: auto;
    max-height: 45vh !important;
    margin-top: 12px !important;
    /* max-height: calc(20vh - 56px)!important; */
  }
}

#V_markDown {
  /* display: block; */
  display: grid;
}

#V_markDown p {
  margin: 0;
  /* display: contents; */
  display: block;
}

#V_markDown table {
  border-collapse: collapse;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: gray;
  display: table;
  text-indent: 0
}

#V_markDown tr {
  border-top: 1px solid #c6cbd1;
  background: #fff
}

#V_markDown td,
#V_markDown th {
  padding: 6px 13px;
  border: 1px solid #dfe2e5
}

#V_markDown table tr:nth-child(2n) {
  background: #f6f8fa
}

#V_markDown li code,
#V_markDown p code {
  background-color: transparent;
  color: blue
}

#V_markDown code.language-markdown,
#V_markDown pre code {
  display: block;
  background: #2b2b2b;
  color: #f0f8ff
}

#V_markDown code {
  white-space: pre-wrap;
  background: #2b2b2b;
  color: #f0f8ff
}

#V_markDown pre code {
  margin: 10px 0px;
}

#V_markDown img {
  max-width: 100%;
  max-height: 320px
}

#V_markDown ul.contains-task-list li {
  margin-top: -20px
}

#V_markDown br {
  content: "";
  margin: 0;
  display: block;
  font-size: 24%
}

#V_markDown li {
  margin-top: -1em;
}


#V_markDown li p {

  margin-top: -22px;
}

#V_markDown li p strong {
  margin-top: -22px;
  display: block;
}




#V_markDown ul {
  margin-bottom: -20px;
}

#V_markDown ol li ul {
  margin-bottom: -40px;
}

/* #V_markDown h1{
  padding-top: 6px;
} */
#V_markDown h1,
#V_markDown h2,
#V_markDown h3,
#V_markDown h4,
#V_markDown h5 {
  /* padding-top: 15px; */

  margin-top: 7.5px;
  margin-bottom: 7.5px;
}

#V_markDown ol {
  margin-bottom: -25px;
}

#V_markDown blockquote {
  margin-top: -35px
}

#V_markDown .container {
  margin-top: 0px;
}

#ModelQuickId::-webkit-scrollbar,
#Editdialog_ID::-webkit-scrollbar {
  height: 10px;
}

#Editdialog_ID::-webkit-scrollbar,
#PrivateMemory::-webkit-scrollbar,
#PrivateMemory_ListFile::-webkit-scrollbar,
#ChatScreId::-webkit-scrollbar,
#ModelQuickId::-webkit-scrollbar,
#toppic_list_id::-webkit-scrollbar,
#NavFullStream .v-navigation-drawer__content::-webkit-scrollbar {
  width: 10px;
}

#Editdialog_ID::-webkit-scrollbar-track,
#PrivateMemory::-webkit-scrollbar-track,
#PrivateMemory_ListFile::-webkit-scrollbar-track,
#ChatScreId::-webkit-scrollbar-track,
#ModelQuickId::-webkit-scrollbar-track,
#toppic_list_id::-webkit-scrollbar-track,
#NavFullStream .v-navigation-drawer__content::-webkit-scrollbar-track {
  background-color: gainsboro;
  border-radius: 5px;
}

#Editdialog_ID::-webkit-scrollbar-thumb,
#PrivateMemory::-webkit-scrollbar-thumb,
#PrivateMemory_ListFile::-webkit-scrollbar-thumb,
#ChatScreId::-webkit-scrollbar-thumb,
#ModelQuickId::-webkit-scrollbar-thumb,
#toppic_list_id::-webkit-scrollbar-thumb,
#NavFullStream .v-navigation-drawer__content::-webkit-scrollbar-thumb {
  /* background-color: rgb(255, 70, 70); */

  background-color: rgb(0, 78, 140);
  /* outline: 1px solid slategrey; */

  border-radius: 5px;

}


@media only screen and (min-width: 1263px) {
  .widthNav {
    /* background-color: red; */
    /* width: calc(100% - 255px) !important; */
    padding: 0px 0px 0px 0px;
    /* width: 80% !important; */

  }
}

.v-navigation-drawer {
  border-radius: 0px 5px 5px 0px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;
}

html {
  overflow: auto;
  overflow-x: clip;
}

.v-main {
  background-color: rgb(239, 239, 245);
}

::-webkit-scrollbar {
  height: 7px !important;
  width: 5px !important;
}

::-webkit-scrollbar-thumb {
  border-radius: 3px !important;
}
</style>

<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
  padding-top: 0.5em;
}

.v-text-field .v-input__append-inner {
  align-self: end !important;
}

.textarea-container {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* counter text-area */
.icon-container {
  position: absolute;
  /* bottom: 25px; */
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: start;
  width: 40%;
  height: 40px;
}

.icon-container-mobile {
  position: absolute;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: start;
  width: 40%;
  height: 40px;
}

.v-textarea__slot {
  padding: 10px;
  /* ปรับค่าตามที่ต้องการ */
}

.custom-textarea .v-input__slot {
  position: relative;
}

.custom-textarea :deep(.v-field__input) {
  mask-image: none !important;
}

textarea.custom-textarea {
  max-height: 7rem;
  overflow: auto;
}

.custom-textarea .v-input__control .v-input__slot .v-text-field__slot {
  margin-bottom: 14px !important;
}

.custom-textarea .v-text-field__slot {
  margin-bottom: 16px !important;
}

/* menu text-area */
.custom-icon {
  position: relative;
  /* bottom: 10px; */
  /* bottom: -25px; */
  bottom: 0;
  right: 0;
}

.custom-icon-mobile {
  /* position: absolute; */
  /* bottom: -25px; */
  bottom: 0;
  right: 0;
}

:deep(.custom-textarea .v-input__prepend-outer) {
  margin-top: 10px !important;
}

:deep(.custom-textarea .v-input__append-outer) {
  margin-top: 0px !important;
  /* display:absolute; */
}

:deep(.custom-textarea .v-input__control .v-input__slot textarea) {
  font-size: 16px !important;
}

:deep(.custom-textarea .v-input__control .v-input__slot fieldset) {
  background-color: #F6F8FA !important;
}

:deep(#book) {
  background-color: white !important;
}

:deep(#book span.v-btn__content .v-icon) {
  color: #FFA41E !important;
}

/* Chat input styling */
.chat-input-container {
  position: relative;
  margin-bottom: 8px;
  border-radius: 12px;
  border: 1px solid gray !important;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s ease;
  border-radius: 15px !important;
  padding-bottom: 8px !important;
}

.chat-input-container:focus-within {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.message-textarea {
  border-radius: 12px !important;
}

.message-textarea :deep(.v-field) {
  padding: 0 8px;
  border-radius: 15px !important;
}

.message-textarea :deep(.v-field__outline) {
  color: transparent !important;
}

.message-textarea :deep(.v-field__input) {
  mask-image: none !important;
}

.message-textarea :deep(.v-field__outline__start),
.message-textarea :deep(.v-field__outline__end),
.message-textarea :deep(.v-field__outline__notch) {
  border-color: transparent !important;
}

.message-textarea:focus-within :deep(.v-field__outline__start),
.message-textarea:focus-within :deep(.v-field__outline__end),
.message-textarea:focus-within :deep(.v-field__outline__notch) {
  border-color: var(--v-theme-primary) !important;
  opacity: 0.3;
}

.message-textarea :deep(textarea) {
  /* background-color: #FFA41E;
  line-height: 1.5;
  padding: 12px 0;
  font-size: 15px !important;
  min-height: 48px;
  max-height: 35vh !important;
  overflow-y: auto; */
  min-height: 48px !important;      /* กำหนดความสูงขั้นต่ำ */
  max-height: 35vh !important;      /* ขีดจำกัดความสูงสูงสุด */
  overflow-y: auto !important;      /* เปิด scrollbar เมื่อเกิน */
  white-space: pre-wrap !important; /* ห่อคำตามบรรทัด */
  word-break: break-word !important;/* หักคำเมื่อยาว */
  resize: vertical !important;      /* ให้ผู้ใช้ปรับขนาดแนวตั้งได้ */
}

.input-hint {
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.chat-input-container:focus-within .input-hint {
  opacity: 1;
}

.char-counter {
  font-size: 12px !important;
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.shortcuts-hint {
  margin-top: 4px;
  text-align: right;
  font-size: 11px;
  width: 100%;
}

.v-textarea ::placeholder {
  font-size: 14px;
  /* Adjust size as needed */
  font-weight: 300;
  opacity: 0.6;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .message-textarea :deep(textarea) {
    font-size: 14px !important;
  }

  .char-counter {
    font-size: 11px !important;
  }
}
/* product card */

.product-recommendations {
  margin: 16px 0 0 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.product-title {
  margin: 0;
  font-size: 16px;
  color: #333;
  display: flex;
  align-items: center;
}

.product-title::before {
  content: '';
  width: 4px;
  height: 16px;
  background-color: var(--v-primary-base);
  margin-right: 8px;
  display: inline-block;
  border-radius: 2px;
}

.product-carousel {
  padding: 12px 16px;
}

.product-scroll {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: thin;
  padding: 5px 0 16px 10px;
}

.product-item {
  flex: 0 0 auto;
  margin-right: 12px;
  width: 250px;
}

.product-card-compact {
  display: flex;
  height: 100px;
  position: relative;
  cursor: pointer;
}

.product-img-container {
  width: 80px;
  height: 80px;
  overflow: hidden;
  margin: 10px;
}

.product-thumbnail {
  border-radius: 4px;
  object-fit: cover;
}

.product-info {
  flex: 1;
  padding: 10px 10px 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.product-name-compact {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.2;
  max-height: 40px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-price {
  color: var(--v-primary-base);
  font-weight: 600;
  font-size: 14px;
}

.product-interest-btn {
  position: absolute;
  bottom: 8px;
  right: 8px;
}

.product-full-description {
  white-space: pre-line;
  line-height: 1.6;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.product-recommendations {
  animation: fadeIn 0.5s ease-out;
}
.container-chat {
  height: calc(-114px + 100dvh);
  display: grid;
  grid-template-columns: 80dvw 10dvw 5dvw;
  grid-template-rows: auto 1fr auto auto;
  grid-template-areas:
    "header header header"
    "main main main"
    "products products products"
    "footer footer footer";
  align-content: space-between;
  justify-content: space-between;
  gap: 0; /* Remove any default gap */
}

/* Update product component styles */
.product-recommendations {
  margin: 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* Update chat container to allow for proper space */
#ChatScreId {
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  flex-grow: 1;
  display: flex;
  max-height: calc(100dvh - 200px)!important;
  flex-direction: column;
  background-color: white;
  border-radius: 5px;
  margin-bottom: 0 !important; /* Remove bottom margin */
}
/* Adjust row styling to remove margins */
v-row[style*="grid-area: main"],
v-row[style*="grid-area: products"] {
  margin: 0 !important;
  padding: 0 !important;
}

/* Fix the textarea container top margin */
v-row[style*="grid-area: footer"] {
  margin-top: 0 !important;
  padding-top: 8px !important;
}

/* 1) ให้กล่อง chat-input-container ไม่ซ่อนสิ่งที่ล้นออกมา */
.chat-input-container {
  overflow: visible !important;
}

/* 2) ให้ตัว message-textarea ไม่ซ่อนสิ่งที่ล้น และ textarea เต็มความสูงเนื้อหา */
.message-textarea,
.message-textarea :deep(textarea) {
  overflow: visible !important;
}

.message-textarea :deep(textarea) {
  max-height: none !important;
  height: auto !important;
  /* ถ้าต้องการให้ยืดอัตโนมัติ */
  resize: vertical !important;
}

.botloader {
    width: 30px;
    height: 30px;
    background: linear-gradient(45deg, #ffddb0, #f19d00, #ffa621);
    border-radius: 50%;
    position: relative;
    box-shadow: 0 0 20px 3px rgba(255, 172, 47, 0.5) inset,
      0 3px 2px rgba(255, 159, 124, 0.3),
      0 0 6px rgba(255, 252, 248, 0.6);
    overflow: hidden;
  }
  .botloader:before,
  .botloader:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 45%;
    top: 0;
    background: linear-gradient(45deg, rgba(255, 219, 152, 0.8), rgba(255, 175, 100, 0.6));
    animation: wave 5s linear infinite;
  }
  .botloader:before {
    border-radius: 30%;
    background: linear-gradient(45deg, rgba(255, 154, 22, 0.6), rgba(255, 190, 133, 0.4));
    animation: wave 5s linear infinite;
  }
  @keyframes wave {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
.botringloader {
  width: 50px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: 
    radial-gradient(farthest-side,#ffa516 94%,#0000) top/4px 4px no-repeat,
    conic-gradient(#0000 30%,#ffa516);
  -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 4px),#000 0);
  animation: l13 1s infinite linear;
}
@keyframes l13{ 
  100%{transform: rotate(1turn)}
}
@keyframes smoothRotate {
  0%, 100% {
    transform: rotate(325deg);
  }
  50% {
    transform: rotate(250deg);
  }
}
.rotating-element {
  animation: smoothRotate 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>
